module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 295);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var _assets_js_utils_use_pwa_signature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15);
/* harmony import */ var _assets_js_utils_log_tracking_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
/**
 * @author kyol
 * @description： 代码设计，手写响应式猜源码
 */


global.auxiliaryVars = global.auxiliaryVars || {
  onloaded: false,
  watchProperties: {}
};
// eslint-disable-next-line no-multi-assign
const {
  auxiliaryVars
} = global;
const awaitListName = String.fromCharCode.apply(null, [81, 117, 101, 117, 101]);
const preFix = String.fromCharCode.apply(null, [117, 115, 101]);
const [preFc, Pipe, append] = ["com", "Pipe", "pose"];
// this is use auxiliary tools
class ObserverData {
  constructor(value) {
    this.value = value;
  }
  toString() {
    return this.value;
  }

  // eslint-disable-next-line class-methods-use-this
  toOrigin() {
    return auxiliaryVars.watchProperties;
  }

  // eslint-disable-next-line class-methods-use-this
  [Symbol.toStringTag]() {
    return "ObserverEffect";
  }
}
const useCacheHooks = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "localStorage";
  return (key, hook) => {
    let value = "";
    const saveType = window[type];
    if (Reflect.has(saveType, key)) {
      value = JSON.parse(saveType.getItem(key));
    } else {
      value = typeof hook !== "function" ? hook : hook();
      saveType.setItem(key, JSON.stringify(value));
    }
    return new Proxy(new ObserverData(value), {
      get(origin, keyName) {
        return Reflect.get(origin, keyName);
      },
      set(origin, keyName, val) {
        if (val === null) {
          saveType.removeItem(key);
        } else {
          saveType.setItem(key, JSON.stringify(val));
        }
        return Reflect.set(origin, keyName, val);
      }
    });
  };
};

/**
 *
 * @param {String} keyName
 * @param {any} definePayload
 * @param {Boolean} isRef  : 是不是ref对象，真是ref,false 为reactive
 * @returns ProxyObserver
 */

const useEffect = function () {
  let isRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (keyName, definePayload) {
    let {
      reset = false,
      ref
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // 构造器
    const seDefval = typeof definePayload === "function" ? definePayload() : definePayload;
    if (!auxiliaryVars.watchProperties[keyName]) {
      auxiliaryVars.watchProperties[keyName] = ref ? ref(seDefval) : new ObserverData(seDefval);
    }
    if (reset) auxiliaryVars.watchProperties[keyName].value = seDefval;
    // 拦截器
    return new Proxy(auxiliaryVars.watchProperties[keyName], {
      get(origin, key) {
        let value = Reflect.get(origin, key);
        if (typeof Reflect.get(origin, "value") === "object" && !isRef) value = Reflect.get(origin.value, key);
        return value;
      },
      set(origin, key, value) {
        return Reflect.set(origin, key, value);
      }
    });
  };
};
const defineFunction = Function || (() => {});
const defineObject = Object || {};
const mapFuncNames = ["forEach", "map", "some", "every", "filter"];
// 扩展USEhooks
const useObjects = mapFuncNames.reduce((p, funcName) => {
  p[funcName] = (object, currayFactory) => originKeys(object)[funcName](hightFn(currayFactory, object));
  return p;
}, {});
useObjects.find = (object, currayFactory) => {
  const amiKey = originKeys(object).find(hightFn(currayFactory, object));
  return amiKey ? {
    key: amiKey,
    value: object[amiKey]
  } : undefined;
};
useObjects.filter = (object, currayFactory) => {
  const amiKeyList = originKeys(object).filter(hightFn(currayFactory, object));
  return amiKeyList.reduce((p, key) => Object.assign(p, {
    [key]: object[key]
  }), {});
};
const originKeys = defineObject.keys.bind(defineObject);
const hightFn = (transformTask, origin) => key => transformTask(origin[key], key, origin);
const useHooks = {
  [`${preFix}Local`]: useCacheHooks(),
  [`${preFix}Session`]: useCacheHooks("sessionStorage"),
  [`${preFix}Ref`]: useEffect(),
  [`${preFix}Reactive`]: useEffect(false),
  [`${preFix}Watch`]: function (watchTask) {
    let watchProNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const keys = typeof watchProNames === "string" ? [watchProNames] : watchProNames;
    const symbolName = Symbol(keys);
    auxiliaryVars.watchEffects[symbolName] = watchTask;
    return symbolName;
  },
  delRef: keyName => {
    return Reflect.defineProperty(auxiliaryVars.watchProperties, keyName);
  },
  isRef: instance => defineObject.prototype.toString().call(instance).slice(8, -1) === "ObserverData",
  [`${preFc}${append}`]: function () {
    for (var _len = arguments.length, warrior = new Array(_len), _key = 0; _key < _len; _key++) {
      warrior[_key] = arguments[_key];
    }
    return function () {
      const unFunc = warrior.findIndex(f => typeof f !== "function");
      // eslint-disable-next-line no-bitwise
      if (~unFunc) return new Error(`${unFunc}坐标参数必须是函数,${warrior[unFunc]}`);
      for (var _len2 = arguments.length, intor = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        intor[_key2] = arguments[_key2];
      }
      return warrior.reduceRight((h, f, i) => warrior.length === i + 1 ? f(...h) : f(h), intor);
    };
  },
  [`${preFix}Memo`]: (cacheValue, cacheReslut) => function (nextValue, task) {
    const curResult = typeof nextValue === "function" ? nextValue() : nextValue;
    if (curResult === cacheValue) return cacheReslut;
    cacheValue = curResult;
    for (var _len3 = arguments.length, list = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      list[_key3 - 2] = arguments[_key3];
    }
    cacheReslut = task(...list);
    return cacheReslut;
  },
  syncToggle: function (data, key, value) {
    let time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 300;
    return new Promise(resolve => {
      const oval = data[key];
      data[key] = value;
      setTimeout(() => {
        data[key] = oval;
        resolve();
      }, time);
    });
  },
  [`${preFix}Toggle`]: function (listValue) {
    let pre = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : listValue[0];
    if (listValue[0] === Boolean) listValue = [true, false];
    let index = listValue.findIndex(v => (typeof pre === "function" ? pre(v) : v) === pre);
    const {
      length
    } = listValue;
    // eslint-disable-next-line no-bitwise
    if (index === length - 1) index = -1;
    pre = listValue[index + 1];
    return listValue[index + 1];
  },
  curryDalay(taskFn) {
    let timer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
    let callback = arguments.length > 2 ? arguments[2] : undefined;
    return function () {
      for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        params[_key4] = arguments[_key4];
      }
      if (taskFn.$beDaley) clearTimeout(taskFn.$beDaley);
      return new Promise(resolve => {
        taskFn.$beDaley = setTimeout(_ => {
          var _taskFn$call;
          callback === null || callback === void 0 ? void 0 : callback(taskFn.call(this, ...params));
          resolve(taskFn === null || taskFn === void 0 ? void 0 : (_taskFn$call = taskFn.call) === null || _taskFn$call === void 0 ? void 0 : _taskFn$call.call(taskFn, this, ...params));
          taskFn.$beDaley = undefined;
        }, timer);
      });
    };
  },
  [`${preFix}${Pipe}`]: pipeFn => params => Promise[pipeFn(params) ? "resolve" : "reject"](params),
  [`${preFix}${awaitListName}`](list, size, curryFn) {
    let index = -1;
    let isOver = false;
    const stop = () => {
      isOver = true;
    };
    const next = async () => {
      if (isOver) return;
      index++;
      const data = list[index];
      if (data === undefined) {
        isOver = true;
      } else {
        const _index = index;
        await data();
        curryFn({
          index: _index,
          next,
          stop
        });
      }
    };
    const startArr = list.slice(0, size);
    startArr.forEach(next);
  }
};
const $wj_tools = {
  $ENV: function () {
    const payload = {
      userAgent: "",
      /*
       * 所有key名对应的value
       * value：[ [第一个数组是需要存在的匹配关键字],[第二个数组是需要不匹配上的关键字] ]
       */
      isWeixin: [["MicroMessenger"], ["wxwork"]],
      isWxwork: [["MicroMessenger", "wxwork"]],
      isLark: [["Lark"]],
      // 飞书
      isDingTalk: [["DingTalk"]] // 钉钉
    };

    const state = {};
    // 存储信息数据
    return {
      // 设置Ua的来源信息
      setUserAgent(ua) {
        Reflect.set(payload, "userAgent", ua);
      },
      // 扩展列表私有属性 payload 对象
      $extend(name, value) {
        if (typeof name === "object") {
          Object.assign(payload, name);
        } else {
          payload[name] = value;
        }
      },
      // 查看对应的key 或者全部key
      viewList(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (key && payload.hasOwnProperty(key)) return Reflect.get(payload, key);
        return payload;
      },
      /**
       * @description： 返回判断环境
       * @param {String in keyof payload} name
       * @return {Boolean}
       *
       */
      get(name) {
        var _global, _global$window, _global$window$naviga;
        // 缓存已经读取过的数据
        if (Reflect.has(state, name)) return Reflect.get(state, name);
        if (name === "userAgent") return Reflect.get(payload, name);
        const [inc = [], exc = []] = Reflect.get(payload, name) || [];
        const au = payload.userAgent || ((_global = global) === null || _global === void 0 ? void 0 : (_global$window = _global.window) === null || _global$window === void 0 ? void 0 : (_global$window$naviga = _global$window.navigator) === null || _global$window$naviga === void 0 ? void 0 : _global$window$naviga.userAgent) || "";
        const status = inc.every(s => au.includes(s)) && exc.every(s => !au.includes(s));
        Reflect.set(state, name, status);
        return status;
      },
      // 移除数据中心
      remove(key) {
        Reflect.deleteProperty(payload, key);
      },
      // thunk执行者函数
      defineState() {
        let middlewareThunk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => ({});
        let keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "defineState";
        // eslint-disable-next-line no-return-assign
        return this[keyName] = function () {
          return middlewareThunk(...arguments);
        };
      }
    };
  }(),
  // 后续扩展其定义
  defineInit() {},
  /**
   *
   * @param {Object} data , 就是接口对象
   * @description : 获取套餐接口数据，格式化有效数据
   * @returns Object <{
   *               version：: 当前版本
   *               expireTime：有效时间
   *               nextVersion：下一个版本
   *           }>
   * }
   */
  formatUserPackageInfo(data) {
    // 套餐类型
    const versiobnMap = ["free", "advance_version", "enterprise_version", "enterprise_ultimate_version"];
    let [version, expireTime, isTry] = ["free", "", false];
    if (data.package_status) {
      /**
       * advance_version 高级版本
       * enterprise_version 企业版标准版
       * enterprise_ultimate_version'; // 企业旗舰版
       */
      isTry = !!data.package_status.is_trial;
      version = data.package_status.version;
      expireTime = data.package_status.expire_time || "";
    }
    // 免费版本能升级,其他版本只能续费
    const index = versiobnMap.indexOf(version); // 当前版本索引
    const nextVersion = versiobnMap[index === versiobnMap.length - 1 ? versiobnMap.length - 1 : index + 1]; // 下一本版本名称
    return {
      version,
      // 当前版本
      expireTime,
      // 有效时间
      nextVersion,
      // 下一个升级版本  名称
      isTry,
      // 是不是试用版
      isFree: version == "free",
      // 是不是免费版本
      isAdv: version === "advance_version" && !isTry,
      // 是不是高级版
      isEnt: version === "enterprise_version" && !isTry,
      // 是不是企业版
      isUlt: version === "enterprise_ultimate_version" && !isTry,
      // 是不是旗舰版
      freeName: "free",
      advName: "advance_version",
      // 高级版名称
      entName: "enterprise_version",
      ultName: "enterprise_ultimate_version"
    };
  },
  /**
   * 校验格式函数
   */
  checkRules: (() => ({
    // 邮箱校验
    isEmail(value, customExp) {
      const exp = customExp || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return exp === null || exp === void 0 ? void 0 : exp.test(value);
    },
    // 国内座机号
    isLandlinePhone(value, customExp) {
      const exp = customExp || /0\d{2,3}-?\d{7,8}/;
      return exp.test(value);
    },
    // 国内手机号
    isMobile(value) {
      let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
      let customExp = arguments.length > 2 ? arguments[2] : undefined;
      const exp = customExp || new RegExp(`^1[3456789]\\d{${size}}$`);
      return exp.test(value);
    },
    // 纯数字 0 - 9
    isNumber(value) {
      return /^[0-9]+$/.test(value);
    },
    standardTofixed(value) {
      let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      const [int, float] = (String(value) || "").split(".");
      const padEnd = (float || "").slice(0, size).padEnd(size, "0");
      return size === 0 ? int : `${int}.${padEnd}`;
    }
  }))(),
  questionTypeList(expendsData) {
    const types = {
      "2": {
        template: "q-select",
        name: "单选",
        formName: "单选",
        satisName: "单选",
        title: "请选择一个选项",
        option: "选项",
        trackName: "single_select"
      },
      "3": {
        template: "q-select",
        name: "多选",
        formName: "多选",
        satisName: "多选",
        title: "请选择以下选项 (多选)",
        subtitle: "单选题",
        option: "选项",
        trackName: "multiple_select"
      },
      "4": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "请选择以下选项",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "5": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "矩阵单选题",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "6": {
        template: "q-blank",
        name: "填空",
        formName: "填空",
        title: "请填写本项内容",
        trackName: "blank"
      },
      "7": {
        template: "q-matrix-default",
        name: "矩阵打分",
        title: "请给以下各项打分",
        satisTitle: "请问你对以下描述的感觉是",
        option: "打分",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "8": {
        template: "q-blank",
        name: "级联题",
        title: "出生日期",
        trackName: "date"
      },
      "9": {
        template: "q-classification",
        name: "分类",
        title: "请按照分类规则，将左侧选项拖入右侧分组中",
        option: "选项",
        suboption: "类别",
        trackName: "classification"
      },
      "50": {
        template: "q-score",
        name: "打分",
        formName: "打分",
        title: "请给本项打分",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "选项",
        trackName: "score"
      },
      "60": {
        template: "q-default",
        name: "排序",
        formName: "排序",
        title: "请给以下选项排序",
        option: "选项",
        trackName: "sort"
      },
      "70": {
        template: "q-desc",
        name: "段落说明",
        title: "请阅读本项说明，然后回答问题",
        trackName: "remark"
      },
      "95": {
        template: "q-multi-blank",
        name: "多项填空",
        title: "请填写以下内容",
        option: "填空",
        trackName: "multiple_blank"
      },
      "100": {
        template: "q-matrix-default",
        name: "矩阵填空",
        title: "请填写以下内容",
        option: "填空",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "105": {
        template: "q-goods",
        name: "商品",
        formName: "商品",
        title: "请挑选您喜欢的商品",
        subtitle: "商品题",
        option: "选项",
        trackName: "goods"
      },
      collection: {
        template: "q-collection",
        name: "收款题",
        formName: "收款",
        createFn: "createCollection",
        trackName: "collection"
      },
      contact_us: {
        template: "q-contact-us",
        name: "联系我们",
        createFn: "createContactUs",
        trackName: "contact_us"
      },
      enterprise_certification_info: {
        template: "q-enterprise-auth",
        createFn: "createEnterpriseAuth",
        name: "企业认证",
        trackName: "enterprise_certification_info"
      },
      user_info: {
        template: "q-user-info",
        name: "个人信息",
        title: "个人信息录入"
      },
      exam_inform: {
        template: "q-exam-inform",
        name: "考前须知",
        title: "考前须知"
      },
      geographical_multiple_blank: {
        template: "q-geographical",
        name: "地理位置",
        title: "所在位置",
        trackName: "geography"
      },
      rich_text: {
        template: "q-rich",
        name: "图文介绍",
        title: "请阅读本项说明，然后回答问题",
        trackName: "rich"
      },
      occupation: {
        template: "q-select",
        name: "职业",
        title: "您目前的职业是？",
        option: "在校学生",
        suboption: "政府/机关干部/公务员",
        trackName: "occupation"
      },
      singlevote: {
        template: "q-default",
        name: "文字投票",
        title: "请给以下选项投票",
        option: "选项",
        trackName: "font_vote"
      },
      education: {
        template: "q-select",
        name: "学历",
        title: "您的最高学历（含目前在读）是？",
        option: "小学及以下",
        suboption: "初中",
        trackName: "education"
      },
      sex: {
        template: "q-select",
        name: "性别",
        title: "性别",
        option: "男",
        suboption: "女",
        trackName: "sex"
      },
      age: {
        template: "q-select",
        name: "年龄",
        satisName: "年龄段",
        title: "您的年龄是？",
        option: "18岁以下",
        suboption: "18~24岁",
        trackName: "age"
      },
      judge: {
        template: "q-select",
        name: "判断题",
        title: "请判断本项叙述是否正确？",
        option: "是",
        suboption: "否",
        trackName: "single_select"
      },
      multiplevote: {
        template: "q-default",
        name: "文字投票题",
        title: "请给以下选项投票（多选）",
        option: "选项",
        trackName: "font_vote_multiple"
      },
      groupvote_single: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票",
        option: "选项",
        trackName: "groupvote_single"
      },
      groupvote_multiple: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票（多选）",
        option: "选项",
        trackName: "groupvote_multiple"
      },
      videovote_single: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票"
      },
      videovote_multiple: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票（多选）"
      },
      listening_single: {
        template: "q-select",
        name: "听力题",
        title: "点击上传音频/视频文件",
        option: "选项",
        trackName: "listen"
      },
      dropdown: {
        template: "q-default",
        name: "下拉",
        formName: "下拉",
        title: "请选择一个选项",
        option: "选项",
        trackName: "dropdown"
      },
      short_answer: {
        template: "q-blank",
        name: "简答题",
        title: "请简要阐述你的观点",
        trackName: "short_answer"
      },
      name: {
        template: "q-blank",
        name: "姓名",
        title: "姓名",
        trackName: "name"
      },
      mobile: {
        template: "q-blank",
        name: "手机",
        title: "手机",
        trackName: "mobile"
      },
      email: {
        template: "q-blank",
        name: "邮箱",
        title: "邮箱",
        trackName: "email"
      },
      wechat_id: {
        template: "q-blank",
        name: "微信号",
        title: "微信号",
        trackName: "wechat_id"
      },
      id_card: {
        template: "q-blank",
        name: "身份证号",
        title: "身份证号",
        trackName: "id_card"
      },
      employee_id: {
        template: "q-blank",
        name: "工号",
        title: "工号",
        trackName: "employee_id"
      },
      blank_num: {
        template: "q-blank",
        name: "数字填空",
        title: "数字",
        trackName: "blank_num"
      },
      classes: {
        template: "q-blank",
        name: "班级",
        title: "班级",
        trackName: "classes"
      },
      grades: {
        template: "q-blank",
        name: "年级",
        title: "年级",
        trackName: "grades"
      },
      student_id: {
        template: "q-blank",
        name: "学号",
        title: "学号",
        trackName: "student_id"
      },
      company: {
        template: "q-blank",
        name: "公司",
        title: "公司",
        trackName: "company"
      },
      department: {
        template: "q-blank",
        name: "部门",
        title: "部门",
        trackName: "department"
      },
      university_form: {
        template: "q-blank",
        name: "学校",
        title: "学校",
        trackName: "university_form"
      },
      major_form: {
        template: "q-blank",
        name: "专业",
        title: "专业",
        trackName: "major_form"
      },
      phone: {
        template: "q-phone",
        trackName: "mobile"
      },
      multi_line_blank: {
        template: "q-multiline-blank",
        trackName: "multiple_blank"
      },
      auto_table: {
        template: "q-auto-table",
        name: "自增表格",
        title: "请填写你的团队成员信息",
        option: "标题",
        trackName: "auto_table"
      },
      horz_blank: {
        template: "q-horz-blank",
        name: "横向填空",
        title: "请填写以下信息",
        option: '姓名<span class="ipt-wrap"><input type="text" style="width: 64px"></span>年龄<span class="ipt-wrap"><input type="text" style="width: 32px"></span>岁<br>联系方式<span class="ipt-wrap"><input type="text" style="width: 88px"></span>',
        trackName: "horizontal_blank"
      },
      cloze: {
        template: "q-cloze",
        name: "完形填空",
        title: "完形填空",
        trackName: "cloze"
      },
      banked_cloze: {
        template: "q-banked-cloze",
        name: "选词填空",
        title: "选词填空",
        option: "选项",
        suboption: ["请输入标题", "的", "地", "得"],
        trackName: "banked_cloze"
      },
      date: {
        template: "q-blank",
        name: "日期",
        title: "日期",
        trackName: "date"
      },
      upload_file: {
        template: "q-upload-file",
        name: "文件收集",
        title: "请上传文件",
        trackName: "upload"
      },
      image_upload: {
        template: "q-image-upload",
        name: "图片收集",
        assessName: "图片收集",
        title: "请上传图片",
        trackName: "image_upload"
      },
      time: {
        template: "q-time",
        name: "时间",
        title: "时间",
        trackName: "time"
      },
      signature: {
        template: "q-signature",
        name: "电子签名",
        subtitle: "请在此处签名",
        title: "签名",
        trackName: "signature"
      },
      image_single: {
        template: "q-image",
        name: "图片选择",
        formName: "图片单选",
        title: "请选择以下图片",
        option: "图片",
        trackName: "image_select"
      },
      image_multiple: {
        template: "q-image",
        name: "图片多选",
        title: "请选择以下图片（多选）",
        option: "图片",
        trackName: "image_multiple"
      },
      imagevote_single: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票",
        option: "图片",
        trackName: "image_vote"
      },
      imagevote_multiple: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票（多选）",
        option: "图片",
        trackName: "image_vote"
      },
      nps_score: {
        template: "q-nps-score",
        name: "NPS",
        formName: "NPS",
        title: "您向朋友或同事推荐我们的可能性有多大？",
        trackName: "nps"
      },
      scale: {
        template: "q-scale",
        name: "量表",
        title: "请您对此项目进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        option: "标题",
        trackName: "scale"
      },
      matrix_scale: {
        template: "q-matrix-scale",
        name: "矩阵量表",
        title: "请您对以下各行内容进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "标题",
        trackName: "matrix_scale"
      },
      city: {
        template: "q-city",
        trackName: "address"
      },
      address: {
        template: "q-address",
        name: "城市/地址",
        formName: "城市/地址",
        satisName: "城市",
        title: "地址",
        trackName: "address"
      },
      major: {
        template: "q-cascader",
        name: "专业",
        trackName: "major"
      },
      industry: {
        template: "q-cascader",
        name: "行业",
        trackName: "industry"
      },
      cascader: {
        template: "q-cascader",
        name: "多级下拉",
        formName: "多级下拉",
        title: "请选择以下选项",
        trackName: "cascader"
      },
      university: {
        template: "q-cascader",
        name: "院校",
        trackName: "university"
      },
      proportion: {
        template: "q-proportion",
        name: "比重",
        formName: "比重",
        title: "请选择以下各项所占的百分比",
        option: "选项",
        trackName: "proportion"
      },
      evaluation: {
        template: "q-evaluation",
        name: "评价",
        formName: "评价",
        title: "请您对我们的服务进行评价",
        subtitle: "单选题",
        option: "选项",
        trackName: "evaluation"
      },
      split_line: {
        template: "q-split-line",
        name: "分割线",
        trackName: "split_line"
      },
      countdown: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      countdown_show_only: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      score_single: {
        template: "q-select",
        title: "请问你对以下描述的感觉是",
        name: "评分单选",
        trackName: "pc_q_grade_single"
      },
      work_age: {
        template: "q-select",
        title: "您的工作年限是？",
        name: "工龄",
        trackName: "pc_q_seniority"
      },
      base_info: {
        template: "q-multi-blank",
        title: "请填写您的基本信息",
        name: "基本信息",
        trackName: "pc_q_basic"
      },
      navigation: {
        template: "q-navigation",
        name: "地图导航",
        trackName: "navigation",
        title: "导航到这里"
      },
      page: {
        template: "q-page",
        name: "分页",
        trackName: "page"
      },
      multiple_dropdown: {
        template: "q-default",
        name: "下拉",
        title: "请选择以下选项 (多选)",
        option: "选项",
        trackName: "dropdown"
      },
      delivery_address: {
        template: "q-delivery-address",
        name: "收货信息",
        title: "请输入收货信息",
        trackName: "delivery_address"
      },
      ...expendsData
    };
    return {
      typeList: Object.keys(types),
      typesData: types,
      // 正向操作
      has() {
        for (var _len5 = arguments.length, keys = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          keys[_key5] = arguments[_key5];
        }
        return keys.every(item => this.typeList.includes(item));
      },
      // 反向操作
      revHas(name) {
        let prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "name";
        let typeKey = "undefined";
        this.typeList.find(
        // eslint-disable-next-line no-return-assign
        key => {
          var _types$key;
          return (types === null || types === void 0 ? void 0 : (_types$key = types[key]) === null || _types$key === void 0 ? void 0 : _types$key[prop]) === name && (typeKey = key);
        });
        return typeKey;
      }
    };
  },
  //  新增接口参数
  appendLoginParams(params) {
    var _this$$route;
    const {
      page_id,
      invite_id,
      reg_from_source,
      reg_fromm_id
    } = (this === null || this === void 0 ? void 0 : (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : _this$$route.query) || {};
    const obj = {
      page_id,
      invite_id,
      reg_from_source,
      reg_fromm_id
    };
    Object.keys(obj).forEach(key => {
      if (obj[key] == 0 || !!obj[key]) params[key] = obj[key];
    });
  },
  usePWASignature: _assets_js_utils_use_pwa_signature_js__WEBPACK_IMPORTED_MODULE_0__,
  logTracker: _assets_js_utils_log_tracking_index_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  defineFunction,
  defineObject,
  useHooks,
  useObjects,
  hooks: {
    install(Vm) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      /**
       * @author: wei
       * @date 24.01.08
       * @description 项目中必使用的扩展函数
       */
      const [FactoryVue, getCurrentInstanceFc] = [Vm, options === null || options === void 0 ? void 0 : options.getCurrentInstance];
      Object.assign(FactoryVue, {
        [`${preFix}Instance`]: () => getCurrentInstanceFc().proxy,
        [`${preFix}Router`]: () => getCurrentInstanceFc().proxy.$router,
        [`${preFix}Route`]: () => getCurrentInstanceFc().proxy.$route,
        [`${preFix}State`]: () => {
          var _getCurrentInstanceFc;
          return (_getCurrentInstanceFc = getCurrentInstanceFc().proxy.$store) === null || _getCurrentInstanceFc === void 0 ? void 0 : _getCurrentInstanceFc.state;
        },
        [`${preFix}Refs`]: () => getCurrentInstanceFc().proxy.$refs,
        [`${preFix}Options`]: options => Object.assign(getCurrentInstanceFc().proxy.$options, options),
        [`${preFix}ReplaceRoute`]() {
          const formatUrl = function () {
            let {
              path = "",
              query = {}
            } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return `${path}${path.includes("?") ? "&" : Object.keys(query).length ? "?" : ""}${Object.keys(query).reduce((p, n, i) => `${p}${i ? "&" : ""}${n}=${query[n]}`, "")}`;
          };
          const setRoute = params => Promise.resolve(history.replaceState(null, null, formatUrl(params)));
          try {
            const {
              useRouter
            } = Vm;
            const Router = useRouter();
            return params => {
              const {
                currentRoute: {
                  path: currentRoutePath = "/"
                }
              } = Router;
              const {
                path
              } = params;
              return path === currentRoutePath ? Router.replace(params).catch(e => {}) : setRoute(params);
            };
          } catch (e) {
            return setRoute;
          }
        },
        ...useHooks
      });
    },
    ...useHooks,
    ...useObjects
  }
};
// if (typeof exports !== "undefined") {
//     export default $wj_tools;
// }
// if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
//     module.exports = $wj_tools;
// }

/* harmony default export */ __webpack_exports__["default"] = ($wj_tools);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(18)))

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/message.css");

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/popover.css");

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

module.exports = require("clipboard");

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/areaInput.vue?vue&type=template&id=5c734e76&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "WdPopover",
    {
      ref: "WdPopover",
      attrs: {
        placement: "bottom-start",
        width: _vm.popWidth,
        "visible-arrow": false,
        "popper-class": "business-areaInput_telpopover",
        offset: _vm.offset,
        "append-to-body": _vm.appendToBody
      },
      on: { hide: _vm.hide }
    },
    [
      _c(
        "div",
        {
          staticClass: "areaInput",
          attrs: { slot: "reference" },
          slot: "reference"
        },
        [
          _c("span", { staticClass: "preIcon" }, [_vm._v("+")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.curValue,
                expression: "curValue"
              }
            ],
            staticClass: "pre-input",
            style: {
              "--preWidth": `${_vm.width}px`
            },
            attrs: { maxlength: "6" },
            domProps: { value: _vm.curValue },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) return
                  _vm.curValue = $event.target.value
                },
                function($event) {
                  return _vm.input("input")
                }
              ],
              change: function($event) {
                return _vm.input("change")
              },
              focus: function($event) {
                return _vm.isfocus(true)
              },
              blur: function($event) {
                return _vm.isfocus(false)
              },
              click: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
              }
            }
          }),
          _vm._v(" "),
          _c("i", {
            class: ["icon wd-icon-caret-bottom", { top: _vm.aine }],
            on: { click: _vm.clickIcon }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "areaInput_pop_content",
            { "default-content": !_vm.$slots.default }
          ]
        },
        [
          _vm._t("default", function() {
            return [
              _c("InternationalCode", {
                ref: "internationalCode",
                attrs: { "tel-code": _vm.TelCode },
                on: { clickItem: _vm.clickItem }
              })
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/complex-input/src/areaInput.vue?vue&type=template&id=5c734e76&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/popover.css"
var popover_css_ = __webpack_require__(133);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/popover"
var popover_ = __webpack_require__(41);
var popover_default = /*#__PURE__*/__webpack_require__.n(popover_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/international-code.vue?vue&type=template&id=9bc956bc&scoped=true&
var international_codevue_type_template_id_9bc956bc_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "international-code", staticClass: "international-code" },
    [
      _c(
        "div",
        { staticClass: "code-left" },
        _vm._l(_vm.telCode, function(item, index) {
          return _c(
            "div",
            { key: "code-left_" + index, staticClass: "code-item" },
            [
              _c(
                "span",
                {
                  class: [
                    "title padding",
                    { "is-active": item.id === _vm.active }
                  ],
                  attrs: { id: item.id === "#" ? "top" : item.id }
                },
                [
                  _c("span", { staticClass: "title-name" }, [
                    _vm._v(_vm._s(item.category))
                  ])
                ]
              ),
              _vm._v(" "),
              _vm._l(item.country, function(c, i) {
                return _c(
                  "span",
                  {
                    key: i + "_" + c.value,
                    staticClass: "body padding",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.$emit("clickItem", c, item, i, index)
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "body-label",
                        attrs: { title: c.label.length >= 8 ? c.label : null }
                      },
                      [_vm._v(_vm._s(c.label))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "body-value" }, [
                      _vm._v(_vm._s(c.value))
                    ])
                  ]
                )
              })
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "code-right" }, [
        _c(
          "p",
          {
            staticClass: "title hover padding",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.clickJump("top")
              }
            }
          },
          [_vm._v("\n            #\n        ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "international-code-body" },
          _vm._l(_vm.telCode.slice(1), function(item, i) {
            return _c(
              "span",
              {
                key: "right_" + i,
                staticClass: "body-label hover padding",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.clickJump(item.id)
                  }
                }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(item.category) +
                    "\n            "
                )
              ]
            )
          }),
          0
        )
      ])
    ]
  )
}
var international_codevue_type_template_id_9bc956bc_scoped_true_staticRenderFns = []
international_codevue_type_template_id_9bc956bc_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/complex-input/src/international-code.vue?vue&type=template&id=9bc956bc&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/international-code.vue?vue&type=script&lang=js&
/* harmony default export */ var international_codevue_type_script_lang_js_ = ({
  name: "InternationalCode",
  props: {
    telCode: {
      type: Array,
      default: Array
    }
  },
  data() {
    return {
      active: ""
    };
  },
  methods: {
    clickJump(id) {
      const target = `#${id}`;
      const dom = this.$refs["international-code"].querySelector(target);
      dom.scrollIntoView({
        behavior: "smooth"
      });
      this.active = id;
    }
  }
});
// CONCATENATED MODULE: ./packages/complex-input/src/international-code.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_international_codevue_type_script_lang_js_ = (international_codevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/international-code.vue?vue&type=style&index=0&id=9bc956bc&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/complex-input/src/international-code.vue?vue&type=style&index=0&id=9bc956bc&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/complex-input/src/international-code.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_international_codevue_type_script_lang_js_,
  international_codevue_type_template_id_9bc956bc_scoped_true_render,
  international_codevue_type_template_id_9bc956bc_scoped_true_staticRenderFns,
  false,
  null,
  "9bc956bc",
  null
  
)

/* harmony default export */ var international_code = (component.exports);
// CONCATENATED MODULE: ./packages/complex-input/src/tel-code.js
const areaCodeList = [{
  id: "#",
  category: "选择国家和地区",
  country: [{
    label: "中国大陆",
    value: "+86"
  }, {
    label: "香港",
    value: "+852"
  }, {
    label: "澳门",
    value: "+853"
  }, {
    label: "台湾",
    value: "+886"
  }]
}, {
  id: "Asia",
  category: "亚洲",
  country: [{
    label: "阿富汗",
    value: "+93"
  }, {
    label: "阿拉伯联合酋长国",
    value: "+971"
  }, {
    label: "阿曼",
    value: "+968"
  }, {
    label: "阿塞拜疆",
    value: "+994"
  }, {
    label: "澳门",
    value: "+853"
  }, {
    label: "巴基斯坦",
    value: "+92"
  }, {
    label: "巴基斯坦",
    value: "+92"
  }, {
    label: "巴勒斯坦",
    value: "+970"
  }, {
    label: "巴林",
    value: "+973"
  }, {
    label: "不丹",
    value: "+975"
  }, {
    label: "朝鲜",
    value: "+850"
  }, {
    label: "东帝汶",
    value: "+670"
  }, {
    label: "俄罗斯联邦/阿布哈兹/南奥赛梯",
    value: "+7"
  }, {
    label: "菲律宾共和国",
    value: "+63"
  }, {
    label: "格鲁吉亚",
    value: "+995"
  }, {
    label: "哈萨克",
    value: "+7"
  }, {
    label: "韩国",
    value: "+82"
  }, {
    label: "吉尔吉斯",
    value: "+996"
  }, {
    label: "柬埔寨",
    value: "+855"
  }, {
    label: "卡塔尔",
    value: "+974"
  }, {
    label: "科威特",
    value: "+965"
  }, {
    label: "老挝",
    value: "+856"
  }, {
    label: "黎巴嫩",
    value: "+961"
  }, {
    label: "马尔代夫",
    value: "+960"
  }, {
    label: "马来西亚",
    value: "+60"
  }, {
    label: "孟加拉国",
    value: "+880"
  }, {
    label: "缅甸",
    value: "+95"
  }, {
    label: "尼泊尔",
    value: "+977"
  }, {
    label: "日本",
    value: "+81"
  }, {
    label: "沙特阿拉伯",
    value: "+966"
  }, {
    label: "圣卢西亚岛",
    value: "+1758"
  }, {
    label: "斯里兰卡",
    value: "+94"
  }, {
    label: "塔吉克",
    value: "+992"
  }, {
    label: "台湾",
    value: "+886"
  }, {
    label: "泰国",
    value: "+66"
  }, {
    label: "土耳其",
    value: "+90"
  }, {
    label: "土库曼",
    value: "+993"
  }, {
    label: "外蒙古",
    value: "+976"
  }, {
    label: "文莱达鲁萨兰国",
    value: "+673"
  }, {
    label: "乌兹别克斯坦",
    value: "+998"
  }, {
    label: "香港",
    value: "+852"
  }, {
    label: "新加坡",
    value: "+65"
  }, {
    label: "叙利亚",
    value: "+963"
  }, {
    label: "亚美尼亚",
    value: "+374"
  }, {
    label: "也门",
    value: "+967"
  }, {
    label: "伊拉克",
    value: "+964"
  }, {
    label: "伊朗",
    value: "+98"
  }, {
    label: "以色列",
    value: "+972"
  }, {
    label: "印度",
    value: "+91"
  }, {
    label: "印度尼西亚",
    value: "+62"
  }, {
    label: "约旦",
    value: "+962"
  }, {
    label: "越南",
    value: "+84"
  }, {
    label: "越南",
    value: "+84"
  }, {
    label: "中国",
    value: "+86"
  }]
}, {
  id: "Europe",
  category: "欧洲",
  country: [{
    label: "阿尔巴尼亚",
    value: "+355"
  }, {
    label: "爱尔兰",
    value: "+353"
  }, {
    label: "爱沙尼亚",
    value: "+372"
  }, {
    label: "安道尔共和国",
    value: "+376"
  }, {
    label: "奥地利",
    value: "+43"
  }, {
    label: "白俄罗斯",
    value: "+375"
  }, {
    label: "保加利亚",
    value: "+359"
  }, {
    label: "比利时",
    value: "+32"
  }, {
    label: "冰岛",
    value: "+354"
  }, {
    label: "波兰",
    value: "+48"
  }, {
    label: "波斯尼亚和黑塞哥维那",
    value: "+387"
  }, {
    label: "丹麦/格陵兰",
    value: "+45"
  }, {
    label: "德国",
    value: "+49"
  }, {
    label: "法国/法国大都会",
    value: "+33"
  }, {
    label: "法罗群岛",
    value: "+298"
  }, {
    label: "芬兰",
    value: "+358"
  }, {
    label: "荷兰",
    value: "+31"
  }, {
    label: "黑山共和国",
    value: "+382"
  }, {
    label: "捷克",
    value: "+420"
  }, {
    label: "克罗地亚",
    value: "+385"
  }, {
    label: "拉脱维亚",
    value: "+371"
  }, {
    label: "立陶宛",
    value: "+370"
  }, {
    label: "列支敦士登",
    value: "+423"
  }, {
    label: "卢森堡",
    value: "+352"
  }, {
    label: "罗马尼亚",
    value: "+40"
  }, {
    label: "马尔他",
    value: "+356"
  }, {
    label: "马其顿",
    value: "+389"
  }, {
    label: "摩尔多瓦",
    value: "+373"
  }, {
    label: "南斯拉夫/塞尔维亚共和国",
    value: "+381"
  }, {
    label: "挪威",
    value: "+47"
  }, {
    label: "葡萄牙",
    value: "+351"
  }, {
    label: "瑞典",
    value: "+46"
  }, {
    label: "瑞士",
    value: "+41"
  }, {
    label: "塞浦路斯",
    value: "+357"
  }, {
    label: "圣马力诺共和国",
    value: "+378"
  }, {
    label: "斯洛伐克",
    value: "+421"
  }, {
    label: "斯洛文尼亚",
    value: "+386"
  }, {
    label: "乌克兰",
    value: "+380"
  }, {
    label: "西班牙",
    value: "+34"
  }, {
    label: "匈牙利",
    value: "+36"
  }, {
    label: "意大利/梵蒂冈",
    value: "+39"
  }, {
    label: "英国/泽西岛",
    value: "+44"
  }, {
    label: "直布罗陀",
    value: "+350"
  }]
}, {
  id: "America",
  category: "美洲",
  country: [{
    label: "阿根廷",
    value: "+54"
  }, {
    label: "阿鲁巴",
    value: "+297"
  }, {
    label: "安圭拉岛",
    value: "+1264"
  }, {
    label: "安提瓜和巴布达",
    value: "+1268"
  }, {
    label: "巴巴多斯",
    value: "+1246"
  }, {
    label: "巴哈马",
    value: "+1242"
  }, {
    label: "巴拉圭",
    value: "+595"
  }, {
    label: "巴拿马",
    value: "+507"
  }, {
    label: "巴西",
    value: "+55"
  }, {
    label: "百慕大",
    value: "+1441"
  }, {
    label: "波多黎各",
    value: "+1787"
  }, {
    label: "玻利维亚",
    value: "+591"
  }, {
    label: "伯利兹城",
    value: "+501"
  }, {
    label: "多米尼加共和国",
    value: "+1849"
  }, {
    label: "多米尼克国",
    value: "+1767"
  }, {
    label: "厄瓜多尔",
    value: "+593"
  }, {
    label: "法属圭亚那",
    value: "+594"
  }, {
    label: "福克兰群岛",
    value: "+500"
  }, {
    label: "哥伦比亚",
    value: "+57"
  }, {
    label: "哥斯达黎加",
    value: "+506"
  }, {
    label: "格林纳达",
    value: "+1473"
  }, {
    label: "古巴",
    value: "+53"
  }, {
    label: "瓜德罗普岛/圣马丁岛",
    value: "+590"
  }, {
    label: "圭亚那",
    value: "+592"
  }, {
    label: "海地",
    value: "+509"
  }, {
    label: "荷兰安的列斯群岛",
    value: "+599"
  }, {
    label: "洪都拉斯",
    value: "+504"
  }, {
    label: "加拿大",
    value: "+1"
  }, {
    label: "开曼群岛",
    value: "+1345"
  }, {
    label: "马提尼克岛",
    value: "+596"
  }, {
    label: "美国",
    value: "+1"
  }, {
    label: "蒙特塞拉特",
    value: "+1664"
  }, {
    label: "秘鲁",
    value: "+51"
  }, {
    label: "墨西哥",
    value: "+52"
  }, {
    label: "尼加拉瓜",
    value: "+505"
  }, {
    label: "萨尔瓦多",
    value: "+503"
  }, {
    label: "圣基茨和尼维斯",
    value: "+1869"
  }, {
    label: "圣皮埃尔岛及密克隆岛",
    value: "+508"
  }, {
    label: "圣文森特和格林纳丁斯",
    value: "+1784"
  }, {
    label: "苏里南",
    value: "+597"
  }, {
    label: "特立尼达和多巴哥",
    value: "+1868"
  }, {
    label: "土克斯及开科斯群岛",
    value: "+1809"
  }, {
    label: "危地马拉",
    value: "+502"
  }, {
    label: "维尔京群岛(英国)",
    value: "+1284"
  }, {
    label: "维尔京群岛(美国)",
    value: "+1340"
  }, {
    label: "委内瑞拉",
    value: "+58"
  }, {
    label: "乌拉圭",
    value: "+598"
  }, {
    label: "牙买加",
    value: "+1876"
  }, {
    label: "智利",
    value: "+56"
  }]
}, {
  id: "Africa",
  category: "非洲",
  country: [{
    label: "阿尔及利亚",
    value: "+213"
  }, {
    label: "阿森松",
    value: "+247"
  }, {
    label: "埃及",
    value: "+20"
  }, {
    label: "埃塞俄比亚",
    value: "+251"
  }, {
    label: "安哥拉",
    value: "+244"
  }, {
    label: "贝宁",
    value: "+229"
  }, {
    label: "博茨瓦纳",
    value: "+267"
  }, {
    label: "布基纳法索",
    value: "+226"
  }, {
    label: "布隆迪",
    value: "+257"
  }, {
    label: "赤道几内亚",
    value: "+240"
  }, {
    label: "多哥",
    value: "+228"
  }, {
    label: "厄立特里亚国",
    value: "+291"
  }, {
    label: "佛得角",
    value: "+238"
  }, {
    label: "冈比亚",
    value: "+220"
  }, {
    label: "刚果",
    value: "+242"
  }, {
    label: "刚果民主共和国",
    value: "+243"
  }, {
    label: "吉布提",
    value: "+253"
  }, {
    label: "几内亚比绍",
    value: "+245"
  }, {
    label: "加纳",
    value: "+233"
  }, {
    label: "加蓬",
    value: "+241"
  }, {
    label: "津巴布韦",
    value: "+263"
  }, {
    label: "喀麦隆",
    value: "+237"
  }, {
    label: "科摩罗",
    value: "+269"
  }, {
    label: "科特迪瓦共和国",
    value: "+225"
  }, {
    label: "肯尼亚",
    value: "+254"
  }, {
    label: "莱索托",
    value: "+266"
  }, {
    label: "利比里亚",
    value: "+231"
  }, {
    label: "利比亚",
    value: "+218"
  }, {
    label: "留尼汪岛/马约特",
    value: "+262"
  }, {
    label: "卢旺达",
    value: "+250"
  }, {
    label: "马达加斯加",
    value: "+261"
  }, {
    label: "马拉维",
    value: "+265"
  }, {
    label: "马里",
    value: "+223"
  }, {
    label: "毛里求斯",
    value: "+230"
  }, {
    label: "毛里塔尼亚",
    value: "+222"
  }, {
    label: "摩洛哥",
    value: "+212"
  }, {
    label: "摩纳哥",
    value: "+377"
  }, {
    label: "莫桑比克",
    value: "+258"
  }, {
    label: "那米比亚",
    value: "+264"
  }, {
    label: "南非",
    value: "+27"
  }, {
    label: "南苏丹共和国",
    value: "+211"
  }, {
    label: "尼日尔",
    value: "+227"
  }, {
    label: "尼日利亚",
    value: "+234"
  }, {
    label: "塞拉利昂",
    value: "+232"
  }, {
    label: "塞内加尔",
    value: "+221"
  }, {
    label: "塞舌尔",
    value: "+248"
  }, {
    label: "圣多美和普林西比",
    value: "+239"
  }, {
    label: "斯威士兰",
    value: "+268"
  }, {
    label: "苏丹",
    value: "+249"
  }, {
    label: "索马里",
    value: "+252"
  }, {
    label: "坦桑尼亚",
    value: "+255"
  }, {
    label: "突尼斯",
    value: "+216"
  }, {
    label: "乌干达",
    value: "+256"
  }, {
    label: "希腊",
    value: "+30"
  }, {
    label: "赞比亚",
    value: "+260"
  }, {
    label: "乍得",
    value: "+235"
  }, {
    label: "中非共和国",
    value: "+236"
  }]
}, {
  id: "Oceania",
  category: "大洋洲",
  country: [{
    label: "澳大利亚/科科斯群岛/圣延岛",
    value: "+61"
  }, {
    label: "巴布亚新几内亚",
    value: "+675"
  }, {
    label: "北马里亚纳群岛",
    value: "+1670"
  }, {
    label: "帛琉",
    value: "+680"
  }, {
    label: "东萨摩亚/萨摩亚",
    value: "+684"
  }, {
    label: "法属玻里尼西亚",
    value: "+689"
  }, {
    label: "斐济",
    value: "+679"
  }, {
    label: "关岛",
    value: "+1671"
  }, {
    label: "基里巴斯",
    value: "+686"
  }, {
    label: "几内亚",
    value: "+224"
  }, {
    label: "库克群岛",
    value: "+682"
  }, {
    label: "马绍尔群岛",
    value: "+692"
  }, {
    label: "美属萨摩亚/西撒哈拉",
    value: "+685"
  }, {
    label: "密克罗尼西亚",
    value: "+691"
  }, {
    label: "瑙鲁",
    value: "+674"
  }, {
    label: "纽埃",
    value: "+683"
  }, {
    label: "诺福克岛",
    value: "+6723"
  }, {
    label: "索罗门群岛",
    value: "+677"
  }, {
    label: "汤加",
    value: "+676"
  }, {
    label: "图瓦卢",
    value: "+688"
  }, {
    label: "托克劳",
    value: "+690"
  }, {
    label: "瓦努阿图",
    value: "+678"
  }, {
    label: "沃利斯和富图纳群岛",
    value: "+681"
  }, {
    label: "夏威夷/威克岛",
    value: "+1808"
  }, {
    label: "新喀里多尼亚",
    value: "+687"
  }, {
    label: "新西兰/皮特凯恩岛",
    value: "+64"
  }]
}];
/* harmony default export */ var tel_code = (areaCodeList);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/areaInput.vue?vue&type=script&lang=js&




/* harmony default export */ var areaInputvue_type_script_lang_js_ = ({
  name: "AreaInput",
  components: {
    WdPopover: popover_default.a,
    InternationalCode: international_code
  },
  emit: {
    checkValue: "核对值" // 核对是不是存在，参数 isHad {label,value} || null
  },

  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    popWidth: {
      type: Number,
      default: 340
    },
    offset: {
      type: Number,
      default: -42
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    // 设置区域的宽度值
    setAearWidth: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      curValue: "",
      aine: false,
      width: 22,
      TelCode: tel_code,
      trigger: "click"
    };
  },
  watch: {
    value: {
      handler(cval) {
        this.formatValue(cval);
      },
      immediate: true
    }
  },
  methods: {
    clickIcon() {
      this.aine = !this.aine;
      this.$emit("clickIcon", this.aine);
    },
    formatValue(cval) {
      var _this$setAearWidth;
      const str = String(cval || "").replace(/\D/g, "");
      this.curValue = str;
      this.width = ((_this$setAearWidth = this.setAearWidth) === null || _this$setAearWidth === void 0 ? void 0 : _this$setAearWidth.call(this, this.curValue)) || 22 + (str.length - 2) * 10;
    },
    // 实时变化的宽度和双向绑定操作
    input(type) {
      this.formatValue(this.curValue);
      this.$emit("input", this.curValue, this.checkValueHad(this.curValue));
      this.$emit("update:value", this.curValue);
      if (type === "change") this.chackChange("change");
    },
    // 关闭旋转Icon
    hide() {
      this.aine = false;
      this.trigger = "manual";
      this.$emit("hide");
    },
    // 核对值是不是存在, 可以在组件中自动判断，也可以手动ref 去执行，获取返回结果
    checkValueHad(value) {
      var _this$curryMap;
      this.checkValueHad.mapList = this.checkValueHad.mapList || ((_this$curryMap = this.curryMap) === null || _this$curryMap === void 0 ? void 0 : _this$curryMap.call(this));
      const isHad = this.checkValueHad.mapList.find(_ref => {
        let {
          value: v
        } = _ref;
        return v.slice(1) === String(value);
      });
      return isHad;
    },
    chackChange() {
      let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "click";
      const isHad = this.checkValueHad(this.curValue);
      // 核对值
      this.$emit("checkValue", isHad);
      if (type === "change") this.$emit("change", this.curValue, isHad);
    },
    // 格式化数组
    curryMap() {
      let finaley = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      const processClicp = list => filed => list.push(filed);
      const processMap = _ref2 => {
        let {
          country
        } = _ref2;
        return country.map(processClicp(finaley));
      };
      this.TelCode.map(processMap);
      return finaley;
    },
    /**
     * c=>当前选中对象
     * item =》 当前分组对象
     * cIndex= 索引
     * index => 分组索引
     */
    clickItem(c, item, cIndex, index) {
      this.curValue = c.value.slice(1);
      this.input();
      // 核对数据,抛出事件
      this.chackChange();
      this.$refs.WdPopover.showPopper = false;
    },
    // 是不是获取焦点
    isfocus() {
      let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      const isHad = !type ? this.checkValueHad(this.curValue) : undefined;
      this.$emit(type ? "focus" : "blur", isHad);
    }
  }
});
// CONCATENATED MODULE: ./packages/complex-input/src/areaInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_areaInputvue_type_script_lang_js_ = (areaInputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/areaInput.vue?vue&type=style&index=0&id=5c734e76&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/complex-input/src/areaInput.vue?vue&type=style&index=0&id=5c734e76&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/areaInput.vue?vue&type=style&index=1&id=5c734e76&prod&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/complex-input/src/areaInput.vue?vue&type=style&index=1&id=5c734e76&prod&lang=scss&

// CONCATENATED MODULE: ./packages/complex-input/src/areaInput.vue







/* normalize component */

var areaInput_component = Object(componentNormalizer["a" /* default */])(
  src_areaInputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "5c734e76",
  null
  
)

/* harmony default export */ var areaInput = __webpack_exports__["a"] = (areaInput_component.exports);

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/loading.css");

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/captcha/src/captcha.vue?vue&type=template&id=4c7d48d8&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["common-captcha", { unMobile: _vm.unMobile }] },
    [
      _vm.autoComplete
        ? _c("input", {
            staticStyle: { display: "none" },
            attrs: { type: "password" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.allArr, function(item) {
        return [
          item === "split"
            ? _c(
                "span",
                { key: item, staticClass: "span-wrap" },
                [
                  _vm._t("default", function() {
                    return [_c("span", { staticClass: "span-split" })]
                  })
                ],
                2
              )
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.curValue[item],
                    expression: "curValue[item]"
                  }
                ],
                key: item,
                ref: "code",
                refInFor: true,
                class: [
                  "common-item kyol_" + item,
                  {
                    error: _vm.errorAll || _vm.curError.includes(item)
                  }
                ],
                attrs: { maxlength: "2", type: "text" },
                domProps: { value: _vm.curValue[item] },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.curValue, item, $event.target.value)
                    },
                    function($event) {
                      return _vm.input(_vm.curValue[item], item)
                    }
                  ],
                  keyup: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                          "Backspace",
                          "Delete",
                          "Del"
                        ])
                      )
                        return null
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.watchMouse(_vm.curValue[item], item)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "left", 37, $event.key, [
                          "Left",
                          "ArrowLeft"
                        ])
                      )
                        return null
                      if ("button" in $event && $event.button !== 0) return null
                      return _vm.move("left", item)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "right", 39, $event.key, [
                          "Right",
                          "ArrowRight"
                        ])
                      )
                        return null
                      if ("button" in $event && $event.button !== 2) return null
                      return _vm.move("right", item)
                    }
                  ],
                  blur: function($event) {
                    return _vm.blur(_vm.curValue[item], item)
                  },
                  click: function($event) {
                    return _vm.shifting(_vm.curValue[item], item)
                  },
                  focus: function($event) {
                    return _vm.focus(_vm.curValue[item], item)
                  },
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    $event.stopPropagation()
                    return _vm.keydownEnter(item)
                  }
                }
              })
        ]
      }),
      _vm._v(" "),
      !_vm.autoComplete
        ? _c("input", { staticClass: "hidden-input" })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/captcha/src/captcha.vue?vue&type=template&id=4c7d48d8&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/captcha/src/captcha.vue?vue&type=script&lang=js&
/* harmony default export */ var captchavue_type_script_lang_js_ = ({
  name: "CommonCaptcha",
  props: {
    value: {
      type: [String, Array],
      default: () => []
    },
    // size：验证码的长度
    size: {
      type: Number,
      default: 6
    },
    // 分隔符的占位索引
    splitIndex: {
      type: Number,
      default: 3
    },
    // 最后返回获取的值的变量 可选值[String,Array]
    valueType: {
      type: String,
      default: "string"
    },
    // 是不是必须是数字
    onleNumber: {
      type: Boolean,
      default: true
    },
    // 错误框的变色索引色
    errorIndexs: {
      type: Array,
      default: () => []
    },
    // 是不是全部显示红色警告
    errorAll: {
      type: Boolean,
      default: false
    },
    // 自动记录错误
    autoError: {
      type: Boolean,
      default: true
    },
    autoComplete: {
      type: Boolean,
      default: false
    },
    //  本地存储是不是要阻止回退报错提示，默认是不阻止的
    stopBackError: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    end: "验证完成"
  },
  data() {
    const arr = Array(this.size).fill(1).map((i, index) => index);
    const allArr = this.splitIndex ? arr.slice(0, this.splitIndex).concat("split", arr.slice(this.splitIndex)) : arr;
    return {
      curValue: arr.reduce((p, n) => Object.assign(p, {
        [n]: ""
      }), {}),
      arr,
      allArr,
      doms: null,
      error: [],
      stopFocus: false,
      unMobile: false,
      isStopBackOnError: false // 本地存储是不是要阻止回退报错提示
    };
  },

  computed: {
    curError() {
      const {
        error,
        errorIndexs
      } = this;
      // eslint-disable-next-line no-underscore-dangle
      const __error = [...errorIndexs];
      if (this.autoError) {
        // 是否自动记录错误
        __error.push(...error);
      }
      return [...new Set([...__error])];
    }
  },
  watch: {
    value: {
      handler(cval) {
        this.arr.forEach((i, index) => {
          this.curValue[index] = cval[index] || "";
        });
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    if (this.size > 0) this.createCopy();
    this.unMobile = !Reflect.has(document.body, "ontouchend");
  },
  beforeDestroy() {
    this.getDoms();
    this.doms.forEach(v => {
      v.removeEventListener("paste", this.paste);
    });
  },
  methods: {
    // 是空值
    isEmpty(value) {
      return !value || value === " ";
    },
    // 校验规则,并自动锁定角色
    input(value, index) {
      if (this.isEmpty(value)) return;
      this.curValue[index] = this.onleNumber ? value.slice(value.length - 1).replace(/\D/g, "") : value.slice(value.length - 1);
      // 最后一个输出值变蓝色
      if (this.isEmpty(this.curValue[index])) return;
      if (index === this.size - 1) this.blur(this.curValue[index], index);
      this.move("right", index);
      this.$nextTick(_ => {
        this.change();
      });
    },
    getDoms() {
      if (!this.doms) this.doms = this.$refs.code;
    },
    // 变化的时候
    change() {
      let allValue = this.arr.reduce((s, n, i) => s + (this.curValue[i] || " "), "");
      allValue = {
        string: allValue,
        array: [...allValue]
      }[this.valueType];
      this.$emit("input", allValue);
      // 结束状态下的值
      if (allValue.length === this.size) this.$emit("end", allValue);
    },
    // 删除当前元素
    watchMouse(value, index) {
      this.isStopBackOnError = this.stopBackError;
      this.$nextTick(_ => {
        this.$emit("delete");
      });
      if (!this.isEmpty(value)) this.curValue[index] = "";
      if (index === 0) return;
      this.getDoms();
      this.doms[index - 1].focus();
      this.change();
    },
    blur(value, index) {
      this.$emit("blur", value, index);
      if (!this.autoError) return; // 关闭自动记录错误
      // 是不是阻止失去焦点的时候 提示红框
      // eslint-disable-next-line no-return-assign
      if (this.isStopBackOnError) return this.isStopBackOnError = false;
      const isHad = this.error.includes(index);
      if (this.isEmpty(value) && !isHad) this.error.push(index);
      if (!this.isEmpty(value) && isHad) this.error.splice(this.error.indexOf(index), 1);
    },
    // 变更数据
    shifting(value, index) {
      if (this.isEmpty(value)) return;
      this.curValue[index] = "";
      this.$nextTick(() => {
        this.curValue[index] = value;
      });
    },
    // 移动对象
    move(direaction, index) {
      this.getDoms();
      const nexIndex = direaction === "left" ? index - 1 : index + 1;
      const [black, dier] = [["left_0", `right_${this.size - 1}`], `${direaction}_${index}`];
      if (black.includes(dier)) return;
      // this.doms[index].blur();
      this.doms[nexIndex].focus();
      this.shifting(this.curValue[nexIndex], nexIndex);
    },
    focus(value, index) {
      if (this.stopFocus) return;
      this.focus.index = index;
      this.$emit("focus", index);
    },
    // 构造监听器
    createCopy() {
      this.getDoms();
      this.doms.forEach(v => {
        v.addEventListener("paste", this.paste, false);
      });
    },
    setFocus() {
      var _this$doms, _this$doms$index;
      let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.getDoms();
      // eslint-disable-next-line no-unused-expressions
      (_this$doms = this.doms) === null || _this$doms === void 0 ? void 0 : (_this$doms$index = _this$doms[index]) === null || _this$doms$index === void 0 ? void 0 : _this$doms$index.focus();
    },
    // 清空数据
    clean() {
      this.curValue = this.arr.reduce((p, n) => Object.assign(p, {
        [n]: ""
      }), {});
      this.change();
    },
    paste(e) {
      var _this = this;
      this.stopFocus = true;
      let data = (e.clipboardData || window.clipboardData).getData("text").slice(0, this.size);
      if (this.onleNumber) {
        data = [...data.replace(/\D/g, "")];
      }
      this.getDoms();
      const {
        index
      } = this.focus;
      const next = data.length;
      // 尾递归
      const recursion = function (index) {
        let dataIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let totle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.size;
        let value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _this.curValue;
        if (index > totle || dataIndex >= next) return;
        if (data[dataIndex]) value[index] = data[dataIndex];
        recursion(++index, ++dataIndex);
      };
      recursion(index);
      this.stopFocus = false;
      setTimeout(() => {
        this.getDoms();
        // eslint-disable-next-line no-underscore-dangle
        const __next = index + next > this.size - 1 ? this.size - 1 : index + next;
        // eslint-disable-next-line no-underscore-dangle
        this.doms[__next].focus();
      });
    },
    // 按下键盘
    keydownEnter() {
      if (Object.values(this.curValue).some(v => this.isEmpty(v))) return;
      this.$emit("keydownEnter");
    }
  }
});
// CONCATENATED MODULE: ./packages/captcha/src/captcha.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_captchavue_type_script_lang_js_ = (captchavue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/captcha/src/captcha.vue?vue&type=style&index=0&id=4c7d48d8&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/captcha/src/captcha.vue?vue&type=style&index=0&id=4c7d48d8&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/captcha/src/captcha.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_captchavue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d48d8",
  null
  
)

/* harmony default export */ var captcha = (component.exports);
// CONCATENATED MODULE: ./packages/captcha/index.js

captcha.install = Vue => {
  Vue.Component(captcha.name, captcha);
};
/* harmony default export */ var packages_captcha = __webpack_exports__["default"] = (captcha);

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dialog.css");

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _countdown_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33);

_countdown_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = Vue => {
  Vue.component(_countdown_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _countdown_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
};
/* harmony default export */ __webpack_exports__["default"] = (_countdown_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCreateProjectUrl", function() { return isCreateProjectUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isUsedPWASignature", function() { return isUsedPWASignature; });
/* harmony import */ var _tools_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/**
 * @description: 项目在 pwa 中访问时，创建项目的接口应带有 pwa 标记，方便后端统计项目创建方式
 */



// 创建项目相关接口
const createProjectUrl = ["/edit/ajax/survey_copy/",
// 复制模板
"/edit/api/create/",
// 空白创建
"/edit/api/copy/",
// 复制已有项目
"/edit/api/textproject/",
// 文本创建
"/edit/api/ref/" // 引用收藏的模板创建
];

// 判断 url 是否为创建项目接口
function isCreateProjectUrl(url) {
  return createProjectUrl.some(item => url.includes(item));
}

// 判断是否使用 pwa 的签名
function isUsedPWASignature(url) {
  const {
    isPWA
  } = Object(_tools_js__WEBPACK_IMPORTED_MODULE_0__[/* distinguishUserAgentUtils */ "b"])();
  if (isPWA && isCreateProjectUrl(url)) {
    return true;
  }
  return false;
}

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_complex_input_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32);

_src_complex_input_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = Vue => {
  Vue.component(_src_complex_input_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _src_complex_input_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
};
/* harmony default export */ __webpack_exports__["default"] = (_src_complex_input_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/assets/js/utils/cookie.js
var cookie = __webpack_require__(5);

// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/base.js

class base_LogBase {
  constructor(source, url) {
    this.source = source;
    this.url = url;
  }
  static createHttpRequest() {
    if (window.ActiveXObject) {
      return new window.ActiveXObject("Microsoft.XMLHTTP");
    }
    if (window.XMLHttpRequest) {
      return new XMLHttpRequest();
    }
  }
  static formatLogData(data) {
    const result = {};
    Object.keys(data).forEach(key => {
      let value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
      if (value !== null && typeof value !== "undefined") {
        value = value.toString();
      }
      result[key] = value;
    });
    return result;
  }

  // eslint-disable-next-line class-methods-use-this
  getExtraData() {
    const extraInfo = ["hawkeye_mid", "browser_id"]; // 默认必传的值
    const cookieData = {};
    extraInfo.forEach(key => {
      cookieData[key] = Object(cookie["b" /* get */])(key);
    });
    const browserData = {
      su: document.referrer
    };
    return Object.assign(cookieData, browserData, {
      pageurl: window.location.href
    });
  }
}
// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/ali-log-tracking.js

class ali_log_tracking_AliLog extends base_LogBase {
  constructor(module) {
    const host = "cn-shanghai.log.aliyuncs.com";
    const project = "wj-applog-prod-10001-sls";
    const logstore = "wj-fed-user-operationlog";
    const url = `//${project}.${host}/logstores/${logstore}/track?APIVersion=0.6.0`;
    super(module, url);
  }
  push(topic, logData) {
    const postData = this.getPostData(topic, logData);
    const request = base_LogBase.createHttpRequest();
    try {
      request.open("POST", this.url, true);
      request.setRequestHeader("x-log-bodyrawsize", 0);
      request.send(JSON.stringify(postData));
    } catch (e) {
      var _window;
      if ((_window = window) !== null && _window !== void 0 && _window.console && typeof window.console.log === "function") {
        console.log(`Failed to log to ali log service because of this exception:\n${e}`);
        console.log("Failed log data:", this.url);
      }
    }
  }
  getExtraData() {
    const extraInfo = super.getExtraData();
    return {
      ...extraInfo
    };
  }
  getPostData(topic, logData) {
    const data = Object.assign(logData, this.getExtraData());
    const logContents = base_LogBase.formatLogData(data);
    return {
      __topic__: topic,
      __source__: this.module,
      __logs__: [logContents]
    };
  }
}
// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/tencent-log-tracking.js

class tencent_log_tracking_TencentLog extends base_LogBase {
  constructor(module) {
    const url = "https://ap-shanghai.cls.tencentcs.com/tracklog?topic_id=89daeb82-6d65-41e9-8a95-f70c8d52ed52";
    super(module, url);
  }
  push(topic, logData) {
    const postData = this.getPostData(topic, logData);
    const request = base_LogBase.createHttpRequest();
    try {
      request.open("POST", this.url, true);
      request.setRequestHeader("Content-type", "application/json");
      request.send(JSON.stringify(postData));
    } catch (e) {
      var _window;
      if ((_window = window) !== null && _window !== void 0 && _window.console && typeof window.console.log === "function") {
        console.log(`Failed to log to tencent log service because of this exception:\n${e}`);
        console.log("Failed log data:", this.url);
      }
    }
  }
  getPostData(topic, logData) {
    var _window2, _window2$location;
    const data = Object.assign(logData, this.getExtraData());
    const logContents = base_LogBase.formatLogData(data);
    return {
      logs: [{
        contents: {
          topic,
          module: this.module,
          ...logContents
        },
        time: new Date().getTime() // TODO: 是否可以不传
      }],

      source: ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.href) || "unknown"
    };
  }
}
// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/index.js


/* harmony default export */ var log_tracking = __webpack_exports__["a"] = ({
  AliLog: ali_log_tracking_AliLog,
  TencentLog: tencent_log_tracking_TencentLog
});

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/index.vue?vue&type=template&id=8d17a12c&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-right-part", class: _vm.openType ? "open-type" : "" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showAgreement && !_vm.showForget,
              expression: "!showAgreement && !showForget"
            }
          ],
          staticClass: "login-right-part_top"
        },
        [
          _c(
            "client-only",
            [
              _vm.currentType === "wx-login"
                ? _c("WXLogin", {
                    ref: "WXLogin",
                    attrs: {
                      "next-url": _vm.nextUrl,
                      "is-accepted": _vm.isAccepted,
                      success: _vm.success,
                      "open-type": _vm.openType,
                      "logo-type": _vm.logoType,
                      source: _vm.source
                    },
                    on: {
                      doAgree: _vm.dealAgreement,
                      loginSuccess: _vm.loginSuccess
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("QuickAccount", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentType != "wx-login",
                expression: "currentType != 'wx-login'"
              }
            ],
            ref: "QuickAccount",
            attrs: {
              "init-type": _vm.currentType,
              "next-url": _vm.nextUrl,
              accepted: _vm.accepted,
              success: _vm.success
            },
            on: {
              dealAgreement: _vm.dealAgreement,
              forgetPwd: _vm.showForgetPwd,
              loginSuccess: _vm.loginSuccess
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.openType == "spsspro"
        ? _c("div", { staticClass: "open-type-title" }, [
            _c("i"),
            _vm._v(" 微信扫码授权登录\n    ")
          ])
        : _c(
            "ThirdParty",
            {
              ref: "ThirdParty",
              attrs: {
                "init-type": _vm.currentType,
                "next-url": _vm.nextUrl,
                success: _vm.success,
                "is-accepted": _vm.isAccepted
              },
              on: {
                iconClick: _vm.handleIconClick,
                change: _vm.changeLoginType,
                doAgree: _vm.dealAgreement,
                loginSuccess: _vm.loginSuccess
              }
            },
            [
              _vm.logoType === "new-logo"
                ? _c("div", { staticClass: "new-logo-agreement" }, [
                    _vm._v("\n            登录即表示您同意\n            "),
                    _c(
                      "a",
                      {
                        staticClass: "primary-text",
                        attrs: { href: "/register/protocol", target: "_blank" }
                      },
                      [_vm._v("《问卷网服务协议》")]
                    ),
                    _vm._v("和\n            "),
                    _c(
                      "a",
                      {
                        staticClass: "primary-text",
                        attrs: { href: "/about/ystk", target: "_blank" }
                      },
                      [_vm._v("《隐私政策》")]
                    )
                  ])
                : _vm._e()
            ]
          ),
      _vm._v(" "),
      _vm.showAgreement && _vm.logoType !== "new-logo"
        ? _c("Agreement", {
            ref: "Agreement",
            attrs: { "is-third": _vm.isThird },
            on: { agreed: _vm.agreed, thirdAgreed: _vm.thirdAgreed }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showForget
        ? _c("Retrieve", {
            ref: "Retrieve",
            on: { forgetPwd: _vm.showForgetPwd }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/login-component/src/index.vue?vue&type=template&id=8d17a12c&scoped=true&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/quick-account/index.vue?vue&type=template&id=0ff1c200&scoped=true&
var quick_accountvue_type_template_id_0ff1c200_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "quick-account-part" },
    [
      _c(
        "ul",
        { staticClass: "tabs", class: [_vm.isQuick ? "left" : "right"] },
        [
          _c(
            "li",
            {
              class: ["tab", _vm.isQuick ? "active" : ""],
              on: {
                click: function($event) {
                  return _vm.chooseType(true)
                }
              }
            },
            [_vm._v("\n            快速登录\n        ")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: ["tab", !_vm.isQuick ? "active" : ""],
              on: {
                click: function($event) {
                  return _vm.chooseType(false)
                }
              }
            },
            [_vm._v("\n            账号登录\n        ")]
          )
        ]
      ),
      _vm._v(" "),
      _c("QuickLogin", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isQuick,
            expression: "isQuick"
          }
        ],
        staticClass: "form-part",
        attrs: {
          "next-url": _vm.nextUrl,
          accepted: _vm.accepted,
          "success-to-task": _vm.successToTask
        },
        on: { dealAgreement: _vm.dealAgreement, loginSuccess: _vm.loginSuccess }
      }),
      _vm._v(" "),
      _c("AccountLogin", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isQuick,
            expression: "!isQuick"
          }
        ],
        staticClass: "form-part",
        attrs: {
          "next-url": _vm.nextUrl,
          "init-type": _vm.initType,
          "success-to-task": _vm.successToTask
        },
        on: { forgetPwd: _vm.forgetPwd, loginSuccess: _vm.loginSuccess }
      })
    ],
    1
  )
}
var quick_accountvue_type_template_id_0ff1c200_scoped_true_staticRenderFns = []
quick_accountvue_type_template_id_0ff1c200_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/login-component/src/quick-account/index.vue?vue&type=template&id=0ff1c200&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dialog.css"
var dialog_css_ = __webpack_require__(14);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dialog"
var dialog_ = __webpack_require__(7);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/button.css"
var button_css_ = __webpack_require__(8);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/button"
var button_ = __webpack_require__(3);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/quick-account/quick-login.vue?vue&type=template&id=4df75086&scoped=true&
var quick_loginvue_type_template_id_4df75086_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "quick-login" },
    [
      _c("ComplexInput", {
        ref: "ComplexInput",
        attrs: {
          "is-error": _vm.accountErr || _vm.accountUnusual,
          "is-active": _vm.canGetVcode,
          maxlength: _vm.accounts.preValue == 86 ? 11 : 15,
          start: _vm.getVcode
        },
        on: {
          input: _vm.watchInput,
          stop: _vm.countDownStop,
          blur: _vm.changeNum,
          checkValue: _vm.areaChange
        },
        model: {
          value: _vm.accounts,
          callback: function($$v) {
            _vm.accounts = $$v
          },
          expression: "accounts"
        }
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.autoVerify || _vm.accountErr,
              expression: "autoVerify || accountErr"
            }
          ],
          staticClass: "phone-bottom-part"
        },
        [
          _vm.autoVerify && _vm.canGetVcode
            ? _c(
                "wd-button",
                {
                  staticClass: "verify-top-8",
                  attrs: { type: "text" },
                  on: { click: _vm.showActiveVerify }
                },
                [_vm._v("发送短信自动验证")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.accountErr,
                  expression: "accountErr"
                }
              ],
              staticClass: "err-text"
            },
            [_vm._v(_vm._s(_vm.accountErrText))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Captcha", {
        ref: "quickCaptcha",
        staticClass: "top-16",
        attrs: {
          "error-all": _vm.vcodeErrorAll,
          "stop-back-error": "",
          "auto-error": false
        },
        on: {
          end: _vm.reInputDone,
          keydownEnter: function($event) {
            return _vm.quickLogin("fromBtn")
          },
          blur: _vm.captchaBlur,
          focus: _vm.captchaFocus
        },
        model: {
          value: _vm.vcode,
          callback: function($$v) {
            _vm.vcode = $$v
          },
          expression: "vcode"
        }
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.vcodeErr,
              expression: "vcodeErr"
            }
          ],
          staticClass: "phone-bottom-part"
        },
        [
          _c("span", { staticClass: "err-text text-left" }, [
            _vm._v(_vm._s(_vm.vcodeErrText))
          ])
        ]
      ),
      _vm._v(" "),
      _vm.accountUnusual
        ? _c("section", { staticClass: "account-error" }, [
            _vm._v("\n        您的账号存在异常，请更换账号或点击"),
            _c("a", { attrs: { href: "/s/UZBZJveegg2", target: "_blank" } }, [
              _vm._v("进行申诉")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "wd-button",
        {
          staticClass: "quick-account-login",
          class: [
            !_vm.canLogin ? "is-disabled" : "",
            _vm.pending ? "is-pending" : ""
          ],
          attrs: {
            type: "primary",
            size: "second",
            disabled: !_vm.canLogin || _vm.pending
          },
          on: {
            click: function($event) {
              return _vm.quickLogin("fromBtn")
            }
          }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pending,
                  expression: "pending"
                }
              ],
              staticClass: "circle-rotate"
            },
            [
              _c("span", { staticClass: "circle-180" }),
              _vm._v(" "),
              _c("span", { staticClass: "circle-90" })
            ]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("登录")])
        ]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "gray-tips" }, [
        _vm._v("\n        未注册手机号验证后自动创建问卷网账号\n    ")
      ]),
      _vm._v(" "),
      _c(
        "wd-dialog",
        {
          staticClass: "active-verify",
          attrs: {
            title: "发送短信完成验证",
            type: "confirm",
            visible: _vm.dialogVisible,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: function($event) {
              _vm.dialogVisible = false
            }
          }
        },
        [
          _c("div", [
            _c("section", { staticClass: "p-line" }, [
              _c("span", { staticClass: "left" }, [
                _c("span", { staticClass: "width-56" }, [_vm._v("使用手机")]),
                _c("span", { staticClass: "left-36" }, [
                  _vm._v(_vm._s(_vm.starNum))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "p-line" },
              [
                _c("span", { staticClass: "left" }, [
                  _c("span", { staticClass: "width-56" }, [_vm._v("编辑短信")]),
                  _c("span", { staticClass: "left-36" }, [
                    _vm._v(_vm._s(_vm.smsContent))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "wd-button",
                  {
                    attrs: { id: "copyBtn", type: "text" },
                    on: {
                      click: function($event) {
                        return _vm.copyWord(_vm.smsContent)
                      }
                    }
                  },
                  [_vm._v("复制")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "p-line" },
              [
                _c("span", { staticClass: "left" }, [
                  _c("span", { staticClass: "width-56" }, [_vm._v("发送至")]),
                  _c("span", { staticClass: "left-36" }, [
                    _vm._v(_vm._s(_vm.smsTarget))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "wd-button",
                  {
                    attrs: { id: "copyBtn", type: "text" },
                    on: {
                      click: function($event) {
                        return _vm.copyWord(_vm.smsTarget)
                      }
                    }
                  },
                  [_vm._v("复制")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer sms-footer-part",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("span", { staticClass: "sms-tips" }, [
                _vm._v("短信费用由运营商收取")
              ]),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "wd-button",
                    {
                      attrs: { type: "info", size: "small" },
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "wd-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.checkSendResult(10)
                        }
                      }
                    },
                    [_vm._v("我已发送")]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "wd-dialog",
        {
          staticClass: "verify-failed",
          attrs: {
            title: "",
            type: "small-center",
            visible: _vm.failedVisible,
            width: "280px"
          },
          on: {
            "update:visible": function($event) {
              _vm.failedVisible = $event
            },
            close: function($event) {
              _vm.failedVisible = false
            }
          }
        },
        [
          _c("div", [
            _c("img", {
              staticClass: "error-icon",
              attrs: { src: _vm.bigErIcon, alt: "验证失败icon" }
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "failed-title" }, [_vm._v("验证失败")]),
            _vm._v(" "),
            _c("p", { staticClass: "failed-word" }, [
              _vm._v(
                "\n                系统未收到手机号" +
                  _vm._s(_vm.starNum) +
                  "发送的短信，请重新发送或者更换手机号\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "wd-button",
                {
                  attrs: { type: "info", size: "tertiary" },
                  on: { click: _vm.changePhoneNum }
                },
                [_vm._v("更换手机")]
              ),
              _vm._v(" "),
              _c(
                "wd-button",
                {
                  attrs: { type: "primary", size: "tertiary" },
                  on: {
                    click: function($event) {
                      _vm.failedVisible = false
                    }
                  }
                },
                [_vm._v("重新发送")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var quick_loginvue_type_template_id_4df75086_scoped_true_staticRenderFns = []
quick_loginvue_type_template_id_4df75086_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/login-component/src/quick-account/quick-login.vue?vue&type=template&id=4df75086&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/loading.css"
var loading_css_ = __webpack_require__(136);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/loading"
var loading_ = __webpack_require__(42);
var loading_default = /*#__PURE__*/__webpack_require__.n(loading_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/message.css"
var message_css_ = __webpack_require__(12);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/message"
var message_ = __webpack_require__(2);
var message_default = /*#__PURE__*/__webpack_require__.n(message_);

// EXTERNAL MODULE: external "lodash/debounce"
var debounce_ = __webpack_require__(44);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

// EXTERNAL MODULE: external "clipboard"
var external_clipboard_ = __webpack_require__(134);
var external_clipboard_default = /*#__PURE__*/__webpack_require__.n(external_clipboard_);

// EXTERNAL MODULE: ./packages/complex-input/index.js
var complex_input = __webpack_require__(159);

// EXTERNAL MODULE: ./packages/captcha/index.js + 7 modules
var captcha = __webpack_require__(139);

// EXTERNAL MODULE: ./src/http/new-login/index.js
var new_login = __webpack_require__(20);

// EXTERNAL MODULE: ./src/assets/js/utils/tools.js
var tools = __webpack_require__(4);

// CONCATENATED MODULE: ./packages/login-component/src/js/manMachine.js

const TencentCaptchaAppId = "193603329";

// 腾讯滑块验证
function manMachineVerificationByTencent() {
  return new Promise((resolve, reject) => {
    if (window.TencentCaptcha) {
      return showCapthcha(resolve, reject);
    }
    Object(tools["h" /* loadJS */])("https://turing.captcha.qcloud.com/TCaptcha.js", () => {
      return showCapthcha(resolve, reject);
    });
  });
}

// 展示滑块验证
function showCapthcha(resolve, reject) {
  const captcha1 = new window.TencentCaptcha(TencentCaptchaAppId, res => {
    const data = {
      rand_str: res.randstr,
      ticket: res.ticket
    };
    if (data.rand_str && data.ticket) {
      resolve(data);
    } else {
      reject(res);
    }
  });
  captcha1.show();
}
// CONCATENATED MODULE: ./packages/login-component/src/js/loginTypeStorage.js
// 登录成功将登录方式写入缓存
// @type
// 快速登录： quick-login; 账号-邮箱登录：email-login; 账号-手机号登录：mobile-login; 微信/第三方登录：wx-login;
function setLastLoginType(type) {
  localStorage.setItem("lastLoginType", type);
}

// 从缓存中获取上次登录方式信息
function getLastLoginType() {
  return localStorage.getItem("lastLoginType") || "wx-login";
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/quick-account/quick-login.vue?vue&type=script&lang=js&















/* harmony default export */ var quick_loginvue_type_script_lang_js_ = ({
  name: "QuickLogin",
  components: {
    ComplexInput: complex_input["default"],
    Captcha: captcha["default"],
    "wd-button": button_default.a,
    "wd-dialog": dialog_default.a
  },
  inject: ["appendParamsFn"],
  props: {
    // 定路由跳转的URL
    nextUrl: {
      type: [String, Function],
      default: "/list/"
    },
    // 是否同意用户协议
    accepted: {
      type: Boolean,
      default: false
    },
    // 成功之后调用回调函数
    success: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      accounts: {
        preValue: 86,
        value: ""
      },
      // 区号&手机号
      accountErr: false,
      // 账号格式不正确
      accountErrText: "请输入有效的手机号",
      // 账号错误提示文案
      vcode: "",
      // 快速登录的二维码信息
      vcodeErrorAll: false,
      vcodeErr: false,
      // 验证码错误提示
      vcodeErrText: "请输入正确的验证码",
      // 验证码错误文案
      accountUnusual: false,
      // 账号异常
      canGetVcode: false,
      // 获取验证码是否高亮可点击
      pending: false,
      // 接口响应中
      // activeType: "quick",
      canClickVcode: true,
      // 发送验证码是否可点击响应
      autoVerify: false,
      // 是否展示自动验证
      captchaSuccess: false,
      // 腾讯滑块是否验证通过
      dialogVisible: false,
      // 自主验证弹框显隐
      dialogLoding: null,
      // 自主验证弹框的loading状态
      smsContent: "问卷网",
      // 自主验证弹框的短信内容
      smsTarget: "10692999341513",
      // 自主验证弹框的目标号码
      clipboard: null,
      // 剪切板
      bigErIcon: "//s1.wenjuan.com/assets/images/business/new-login/big-error-icon.png",
      // 验证失败icon
      failedVisible: false // 验证失败弹框
      // token: null // 自主验证成功的token
    };
  },

  computed: {
    // 登录按钮是否可点击
    canLogin() {
      // 区号和手机号验证通过
      if (this.canGetVcode && this.vcode && this.vcode.length === 6) {
        return true;
      }
      return false;
    },
    // 手机中间四位星号
    starNum() {
      if (this.accounts.value) {
        return `${this.accounts.value.toString().slice(0, 3)}****${this.accounts.value.toString().slice(-4)}`;
      }
      return "";
    }
  },
  watch: {
    accepted(val) {
      // 如果同意用户协议的话，调用登录接口走登录逻辑
      if (val) {
        this.quickLogin();
      }
    }
  },
  methods: {
    // 手机号输入框input时
    changeNum(obj) {
      if (obj.type === "areaBlur") return;
      this.checkAreaAndPhone(obj);
    },
    // 区号点击更改
    areaChange(obj) {
      this.checkAreaAndPhone(obj);
    },
    // 校验区号和手机号格式
    checkAreaAndPhone(obj) {
      this.accountUnusual = false;
      this.accountErr = false;
      if (!obj.value.preValue) {
        this.accountErrText = "请输入区号";
        this.accountErr = true;
      } else if (!obj.value.value) {
        this.accountErrText = "请输入手机号";
        this.accountErr = true;
      } else if (!obj.isHad) {
        this.accountErrText = "请输入有效的区号";
        this.accountErr = true;
      } else if (obj.value.preValue == 86 && !/^1[3456789]\d{9}$/.test(obj.value.value) || obj.value.preValue != 86 && (obj.value.value.length < 4 || obj.value.value.length > 15)) {
        this.accountErrText = "请输入有效的手机号";
        this.accountErr = true;
      } else {
        this.accountErr = false;
      }
    },
    watchInput: debounce_default()(function (obj, flag) {
      this.getVcodeBtnStatus(obj, flag);
    }, 500),
    // 获取验证码按钮高亮状态判断
    getVcodeBtnStatus(obj, flag) {
      // 国内手机号，必须是11位，第一位必须为1，第二位必须是3-9
      // 国际手机号，4-15位即可
      // flag: 存在的区号flag为对象，不存在的区号flag为undefined
      if (obj.preValue == 86 && /^1[3456789]\d{9}$/.test(obj.value) || obj.preValue != 86 && flag && obj.value.length >= 4 && obj.value.length <= 15) {
        this.canGetVcode = true;
      } else {
        this.canGetVcode = false;
      }
    },
    // 发送验证码倒计时结束，展示自主验证入口且按钮可再次点击
    countDownStop() {
      this.autoVerify = true;
      this.canClickVcode = true;
    },
    // 获取验证码，是否显示图像验证码，短信验证码是否发送成功
    async getVcode() {
      if (!this.canClickVcode) {
        return;
      }
      try {
        // 验证手机号和区号
        this.checkAreaAndPhone({
          value: this.accounts,
          isHad: this.$refs.ComplexInput.getIsHad()
        });
        if (this.accountErr) {
          return;
        }
        let data = {
          identifier: `+${this.accounts.preValue}${this.accounts.value}`
        };
        if (this.captchaSuccess) {
          data = {
            identifier: `+${this.accounts.preValue}${this.accounts.value}`,
            captcha_success: this.captchaSuccess
          };
        }
        const res = await Object(new_login["d" /* httpGetVcode */])(data);
        if (res.status === 200 && res.status_code === 1) {
          if (res.data.is_show_captcha) {
            // 显示腾讯滑块
            this.tencentManMachineVerificatio();
          }
          if (res.data.is_vcode) {
            this.canClickVcode = false;
            this.$refs.ComplexInput.startRunTime();
            // 验证码组件聚焦第一个输入框
            this.$refs.quickCaptcha.setFocus();
          }
        } else if (res.err_code == 300004) {
          this.accountUnusual = true;
          this.vcodeErr = false;
        } else if (res.err_msg) {
          this.accountErrText = res.err_msg;
          this.accountErr = true;
        } else {
          return Promise.reject(res);
        }
      } catch (err) {
        var _err$data, _err$data2;
        if (typeof err === "object" && ((_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.err_code) == 300004) {
          this.accountUnusual = true;
          this.vcodeErr = false;
        } else if ((_err$data2 = err.data) !== null && _err$data2 !== void 0 && _err$data2.err_msg) {
          var _err$data3;
          this.accountErrText = (_err$data3 = err.data) === null || _err$data3 === void 0 ? void 0 : _err$data3.err_msg;
          this.accountErr = true;
        } else {
          return Promise.reject(err);
        }
      }
    },
    // 腾讯滑块验证逻辑
    tencentManMachineVerificatio() {
      manMachineVerificationByTencent().then(res => {
        this.captchaSuccess = true;
        // 验证成功后继续调用调用发送验证码接口获取验证码
        this.getVcode();
      }).catch(err => {
        this.captchaSuccess = false;
      });
    },
    // 验证码focus
    captchaFocus() {
      this.vcodeErrorAll = false;
      this.vcodeErr = false;
    },
    // 验证码失焦
    captchaBlur(val) {
      if (!val && this.vcode.length === 0) {
        this.vcodeErrorAll = true;
        this.vcodeErrText = "请输入验证码";
        this.vcodeErr = true;
      } else if (!val && (this.vcode.length > 0 || this.vcode.length < 6)) {
        this.vcodeErrorAll = true;
        this.vcodeErrText = "请输入正确的验证码";
        this.vcodeErr = true;
      }
    },
    // 验证码输入完整
    reInputDone() {
      this.vcodeErr = false;
      this.vcodeErrorAll = false;
    },
    // 快速登录点击登录按钮后的登录逻辑
    // 此接口的三种情况：
    // 正常老用户是手机号+验证码
    // 新用户：手机号+验证码+同意用户协议
    // 收不到验证码，主动发送验证流程：手机号+token，如果是新用户就是手机号+token+用户协议
    // 流程中断需要将token都置空
    quickLogin(str) {
      if (this.pending) {
        return;
      }
      // 再次登录时重置报错
      this.resetErrTips();
      this.pending = true;
      // 如果是登录按钮点击的登录，置空token，避免之前自主验证生成的token影响登录
      if (str === "fromBtn") {
        this.token = "";
      }
      const data = {
        identifier: `+${this.accounts.preValue}${this.accounts.value}`
      };
      if (this.token) {
        Object.assign(data, {
          token: this.token
        });
      }
      if (this.accepted) {
        Object.assign(data, {
          agree_agreement: true
        });
      }
      if (this.vcode) {
        Object.assign(data, {
          vcode: this.vcode
        });
      }
      // 新用户注册并登录，老用户直接登录，返回登录是否成功
      this.appendParamsFn(data);
      Object(new_login["f" /* httpQuickLogin */])(data).then(async res => {
        if (res.status === 200 && res.status_code === 1) {
          if (res.data.is_new_member) {
            // 新用户，展示用户协议弹框
            this.$emit("dealAgreement", true);
            this.pending = false;
          }
          if (res.data.is_login) {
            this.$refs.ComplexInput.dispatchStop();
            this.canGetVcode = false;
            this.$emit("loginSuccess", "quick-acount");
            // 记录登录方式
            setLastLoginType("quick-login");
            // 登录成功该跳转跳转，该刷新页面刷新页面
            typeof this.nextUrl === "function" ? await this.nextUrl() : this.nextUrl && (window.location.href = this.nextUrl);
            this.sucess && this.sucess();
            setTimeout(() => {
              this.pending = false;
            }, 2000);
          }
        } else if (res.err_code == 300004) {
          this.pending = false;
          this.accountUnusual = true;
          this.vcodeErr = false;
          this.vcode = "";
        } else {
          this.pending = false;
          this.vcodeErrorAll = true;
          this.vcodeErrText = res === null || res === void 0 ? void 0 : res.err_msg;
          this.vcodeErr = true;
          this.accountUnusual = false;
          this.vcode = "";
        }
      }).catch(err => {
        var _err$data4, _err$data5;
        this.pending = false;
        this.vcode = "";
        if (typeof err === "object" && ((_err$data4 = err.data) === null || _err$data4 === void 0 ? void 0 : _err$data4.err_code) == 300004) {
          this.accountUnusual = true;
          this.vcodeErr = false;
        } else if (typeof err === "object" && (_err$data5 = err.data) !== null && _err$data5 !== void 0 && _err$data5.err_msg) {
          this.vcodeErrorAll = true;
          this.vcodeErrText = err.data.err_msg;
          this.vcodeErr = true;
          this.accountUnusual = false;
        } else {
          message_default()({
            message: "网络异常，请重新登录",
            type: "warning"
          });
          return Promise.reject(err);
        }
      });
    },
    // 显示主动验证弹框
    showActiveVerify() {
      if (!this.accounts.value) {
        message_default()({
          message: "请输入有效的手机号",
          type: "warning"
        });
        return;
      }
      this.dialogVisible = true;
      Object(new_login["h" /* httpUploadValidate */])().then(res => {
        if (res.status === 200 && res.status_code === 1) {
          this.smsContent = res.data.content;
          this.smsTarget = res.data.channel;
        } else {
          this.pending = false;
        }
      }).catch(err => {
        var _err$data6;
        this.pending = false;
        if (typeof err === "object" && (_err$data6 = err.data) !== null && _err$data6 !== void 0 && _err$data6.err_msg) {
          message_default()({
            message: err.data.err_msg,
            type: "warning"
          });
        } else {
          return Promise.reject(err);
        }
      });
    },
    // 主动验证弹框中的复制
    copyWord(word) {
      if (this.clipboard) this.clipboard.destroy();
      this.clipboard = new external_clipboard_default.a("#copyBtn", {
        text: () => word
      });
      this.clipboard.on("success", () => {
        message_default()({
          message: "已复制",
          type: "success"
        });
      });
      this.clipboard.on("error", () => {
        message_default()({
          message: "该浏览器不支持自动复制，请手动复制！",
          type: "warning"
        });
      });
    },
    // 主动验证弹框检查发送结果
    checkSendResult(requestNum) {
      if (!this.dialogLoding || requestNum === 10) {
        this.dialogLoding = loading_default.a.service({
          target: document.querySelector(".active-verify .wd-dialog"),
          text: "验证中"
        });
      }
      Object(new_login["b" /* httpCheckUploadValidate */])({
        use_for: "quick_login",
        phone: this.accounts.value,
        content: this.smsContent
      }).then(res => {
        requestNum--;
        if (res.status === 200 && res.status_code === 1) {
          if (res.data.is_sent) {
            // 拿到token信息掉登录接口
            this.token = res.data.token;
            this.quickLogin();
            this.dialogLoding.close();
            this.dialogVisible = false;
          } else if (requestNum > 0) {
            setTimeout(() => {
              this.checkSendResult(requestNum);
            }, 1000);
          } else {
            // 展示验证失败弹框
            this.failedVisible = true;
            this.dialogLoding.close();
          }
        } else {
          this.dialogLoding.close();
        }
      }).catch(err => {
        var _err$data7;
        this.dialogLoding.close();
        if (typeof err === "object" && (_err$data7 = err.data) !== null && _err$data7 !== void 0 && _err$data7.err_msg) {
          message_default()({
            message: err.data.err_msg,
            type: "warning"
          });
        } else {
          return Promise.reject(err);
        }
      });
    },
    // 自主验证弹框验证失败，更换手机号
    changePhoneNum() {
      this.failedVisible = false;
      this.dialogVisible = false;
      this.autoVerify = false;
      // 更换手机号，手机号和验证码置空
      this.accounts = {
        preValue: "86",
        value: ""
      };
      this.vcode = "";
      this.resetErrTips();
    },
    // 重置错误信息
    resetErrTips() {
      this.accountUnusual = false;
      this.accountErr = false;
      this.vcodeErr = false;
      this.vcodeErrorAll = false;
    }
  }
});
// CONCATENATED MODULE: ./packages/login-component/src/quick-account/quick-login.vue?vue&type=script&lang=js&
 /* harmony default export */ var quick_account_quick_loginvue_type_script_lang_js_ = (quick_loginvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/quick-account/quick-login.vue?vue&type=style&index=0&id=4df75086&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/login-component/src/quick-account/quick-login.vue?vue&type=style&index=0&id=4df75086&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/quick-account/quick-login.vue?vue&type=style&index=1&id=4df75086&prod&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/login-component/src/quick-account/quick-login.vue?vue&type=style&index=1&id=4df75086&prod&lang=scss&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/login-component/src/quick-account/quick-login.vue







/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  quick_account_quick_loginvue_type_script_lang_js_,
  quick_loginvue_type_template_id_4df75086_scoped_true_render,
  quick_loginvue_type_template_id_4df75086_scoped_true_staticRenderFns,
  false,
  null,
  "4df75086",
  null
  
)

/* harmony default export */ var quick_login = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/quick-account/account-login.vue?vue&type=template&id=47385ad7&scoped=true&
var account_loginvue_type_template_id_47385ad7_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "account-login" },
    [
      _c("ComplexInput", {
        ref: "accountInput",
        attrs: {
          "use-area": _vm.showArea,
          "use-code": false,
          "is-error": _vm.accountErr || _vm.accountUnusual,
          maxlength: _vm.showArea
            ? _vm.accounts.preValue == 86
              ? 11
              : 15
            : -1,
          "value-type": _vm.showArea ? "number" : "",
          placeholder: _vm.placeholder
        },
        on: {
          input: _vm.watchInput,
          blur: _vm.checkAccount,
          checkValue: _vm.areaChange
        },
        model: {
          value: _vm.accounts,
          callback: function($$v) {
            _vm.accounts = $$v
          },
          expression: "accounts"
        }
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.accountErr,
              expression: "accountErr"
            }
          ],
          staticClass: "phone-bottom-part"
        },
        [
          _c("span", { staticClass: "err-text" }, [
            _vm._v(_vm._s(_vm.accountErrText))
          ])
        ]
      ),
      _vm._v(" "),
      _c("wd-input", {
        staticClass: "top-16 pwd-input",
        attrs: {
          placeholder: "请输入密码",
          "show-password": "",
          oncopy: "return false",
          oncut: "return false",
          "is-error": _vm.pwdErr
        },
        on: { input: _vm.pwdInput, blur: _vm.checkPassword },
        model: {
          value: _vm.password,
          callback: function($$v) {
            _vm.password = $$v
          },
          expression: "password"
        }
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.pwdErr,
              expression: "pwdErr"
            }
          ],
          staticClass: "phone-bottom-part"
        },
        [
          _c("span", { staticClass: "err-text" }, [
            _vm._v(_vm._s(_vm.pwdErrText))
          ])
        ]
      ),
      _vm._v(" "),
      _vm.accountUnusual
        ? _c("section", { staticClass: "account-error" }, [
            _vm._v("\n        您的账号存在异常，请更换账号或点击"),
            _c("a", { attrs: { href: "/s/UZBZJveegg2", target: "_blank" } }, [
              _vm._v("进行申诉")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "wd-button",
        {
          staticClass: "quick-account-login",
          class: [_vm.pending ? "is-pending" : ""],
          attrs: {
            type: "primary",
            size: "second",
            disabled: !_vm.canLogin || _vm.pending
          },
          on: { click: _vm.accountLogin, inputed: _vm.inputed }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pending,
                  expression: "pending"
                }
              ],
              staticClass: "circle-rotate"
            },
            [
              _c("span", { staticClass: "circle-180" }),
              _vm._v(" "),
              _c("span", { staticClass: "circle-90" })
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { "data-flag": `${!_vm.canLogin}-${_vm.pending}` } },
            [_vm._v("登录")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "switch-account" },
        [
          _c(
            "wd-button",
            { attrs: { type: "text" }, on: { click: _vm.switchType } },
            [_vm._v(_vm._s(_vm.showArea ? "使用邮箱登录" : "使用国际手机号"))]
          ),
          _vm._v(" "),
          _c(
            "wd-button",
            {
              staticClass: "gray-word",
              attrs: { type: "text" },
              on: {
                click: function($event) {
                  return _vm.$emit("forgetPwd", true)
                }
              }
            },
            [_vm._v("忘记密码")]
          )
        ],
        1
      )
    ],
    1
  )
}
var account_loginvue_type_template_id_47385ad7_scoped_true_staticRenderFns = []
account_loginvue_type_template_id_47385ad7_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/login-component/src/quick-account/account-login.vue?vue&type=template&id=47385ad7&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/input.css"
var input_css_ = __webpack_require__(19);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/input"
var input_ = __webpack_require__(9);
var input_default = /*#__PURE__*/__webpack_require__.n(input_);

// EXTERNAL MODULE: external "blueimp-md5"
var external_blueimp_md5_ = __webpack_require__(27);
var external_blueimp_md5_default = /*#__PURE__*/__webpack_require__.n(external_blueimp_md5_);

// EXTERNAL MODULE: ./packages/complex-input/src/complex-input.vue + 6 modules
var src_complex_input = __webpack_require__(32);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/quick-account/account-login.vue?vue&type=script&lang=js&











/* harmony default export */ var account_loginvue_type_script_lang_js_ = ({
  name: "AccountLogin",
  components: {
    "wd-button": button_default.a,
    "wd-input": input_default.a,
    ComplexInput: src_complex_input["a" /* default */]
  },
  props: {
    // 定路由跳转的URL
    nextUrl: {
      type: [String, Function],
      default: "/list/"
    },
    initType: {
      type: String,
      default: "email-login"
    }
  },
  data() {
    return {
      accounts: {},
      // 账号
      password: "",
      // 密码
      pwdErr: false,
      // 密码错误提醒
      pwdErrText: "请输入密码",
      accountErr: false,
      // 账号错误提示
      accountErrText: "请输入有效的手机号或邮箱",
      // 账号错误提示信息
      accountUnusual: false,
      // 账号异常
      pending: false,
      // 登录中
      showArea: this.initType === "mobile-login" // 显示区号
    };
  },

  computed: {
    placeholder() {
      if (this.showArea) {
        return "请输入手机号";
      }
      return "请输入手机号或邮箱";
    },
    // 登录按钮是否可点击
    canLogin() {
      if (this.showArea && this.accounts.preValue == 86 && /^1[3456789]\d{9}$/.test(this.accounts.value) || this.accounts.preValue != 86 && this.$refs.accountInput && this.$refs.accountInput.getIsHad() && this.accounts.value.length >= 4 && this.accounts.value.length <= 15 && this.password) {
        // 国际手机号登录可登录的条件
        return true;
      }
      if (!this.showArea && (/^1[3456789]\d{9}$/.test(this.accounts.value) || /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.accounts.value)) && this.password) {
        // 国内手机号+邮箱的方式可登录的条件
        return true;
      }
      return false;
    }
  },
  watch: {
    initType(val) {
      this.showArea = val === "mobile-login";
    }
  },
  methods: {
    // 交互写的有点乱，失焦点 Input 都在做一个事，导致相互覆盖。
    watchInput: debounce_default()(function (obj, flag) {
      this.accountUnusual = false;
      // 邮箱禁止中文输入
      if (!this.showArea) {
        this.accounts.value = obj.value.replace(/\s|[\u4E00-\u9FA5]/g, "");
      }
    }, 200),
    // 账号登录点击登录按钮后的登录逻辑
    accountLogin() {
      if (this.pending) {
        return;
      }
      this.pending = true;
      const params = {
        account: this.showArea ? `+${this.accounts.preValue}${this.accounts.value}` : this.accounts.value,
        password: external_blueimp_md5_default()(this.password)
      };
      Object(new_login["a" /* httpAccountLogin */])(params).then(res => {
        if (res.status === 200 && res.status_code === 1) {
          this.pending = false;
          // 记录登录方式
          setLastLoginType(this.showArea ? "mobile-login" : "email-login");
          this.$emit("loginSuccess", this.showArea ? "mobile-login" : "email-login");
          // 登录成功该跳转跳转，该刷新页面刷新页面
          typeof this.nextUrl === "function" ? this.nextUrl() : this.nextUrl && (window.location.href = this.nextUrl);
          setTimeout(() => {
            this.pending = false;
          }, 2000);
        } else if (res.err_code == 300004) {
          this.pending = false;
          this.accountUnusual = true;
          this.pwdErr = false;
        } else {
          this.pending = false;
          this.pwdErrText = res.err_msg;
          this.pwdErr = true;
          this.accountUnusual = false;
        }
      }).catch(err => {
        var _err$data, _err$data2;
        this.pending = false;
        if (typeof err === "object" && ((_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.err_code) == 300004) {
          this.accountUnusual = true;
          this.pwdErr = false;
        } else if (typeof err === "object" && (_err$data2 = err.data) !== null && _err$data2 !== void 0 && _err$data2.err_msg) {
          this.pwdErrText = err.data.err_msg;
          this.pwdErr = true;
          this.accountUnusual = false;
        } else {
          message_default()({
            message: "网络异常，请重新登录",
            type: "warning"
          });
          return Promise.reject(err);
        }
      });
    },
    // 切换账号登录方式（国内手机号或邮箱，国际手机号）
    switchType() {
      this.accountErr = false;
      this.accounts.value = "";
      this.password = "";
      this.showArea = !this.showArea;
    },
    // 失焦判断正好的正确性
    checkAccount(obj) {
      //  区域组件失去焦点的时候不出发事件
      if (obj.type === "areaBlur") return;
      if (this.showArea) {
        // 国际手机号
        if (!obj.value.preValue) {
          this.accountErrText = "请输入区号";
          this.accountErr = true;
        } else if (!obj.value.value) {
          this.accountErrText = "请输入手机号";
          this.accountErr = true;
        } else if (!obj.isHad) {
          this.accountErrText = "请输入有效的区号";
          this.accountErr = true;
        } else if (obj.value.preValue == 86 && !/^1[3456789]\d{9}$/.test(obj.value.value) || obj.value.preValue != 86 && (obj.value.value.length < 4 || obj.value.value.length > 15)) {
          this.accountErrText = "请输入有效的手机号";
          this.accountErr = true;
        } else {
          this.accountErr = false;
        }
      } else {
        // 国内手机号或邮箱
        // eslint-disable-next-line no-lonely-if
        if (!obj.value.value) {
          this.accountErrText = "请输入手机号或邮箱";
          this.accountErr = true;
        } else if (!/^1[3456789]\d{9}$/.test(obj.value.value) && !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(obj.value.value)) {
          this.accountErrText = "请输入有效的手机号或邮箱";
          this.accountErr = true;
        } else {
          this.accountErr = false;
        }
      }
    },
    areaChange(obj) {
      this.checkAccount(obj);
    },
    // 失焦判断密码是否为空
    checkPassword() {
      if (!this.password) {
        this.pwdErrText = "请输入密码";
        this.pwdErr = true;
      } else {
        this.pwdErr = false;
      }
    },
    // 密码框不能输入空格
    pwdInput(val) {
      this.password = val.replace(/\s|[\u4E00-\u9FA5]/g, "");
    },
    inputed() {
      console.log("自动填充-----------------");
    }
  }
});
// CONCATENATED MODULE: ./packages/login-component/src/quick-account/account-login.vue?vue&type=script&lang=js&
 /* harmony default export */ var quick_account_account_loginvue_type_script_lang_js_ = (account_loginvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/quick-account/account-login.vue?vue&type=style&index=0&id=47385ad7&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/login-component/src/quick-account/account-login.vue?vue&type=style&index=0&id=47385ad7&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/login-component/src/quick-account/account-login.vue






/* normalize component */

var account_login_component = Object(componentNormalizer["a" /* default */])(
  quick_account_account_loginvue_type_script_lang_js_,
  account_loginvue_type_template_id_47385ad7_scoped_true_render,
  account_loginvue_type_template_id_47385ad7_scoped_true_staticRenderFns,
  false,
  null,
  "47385ad7",
  null
  
)

/* harmony default export */ var account_login = (account_login_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/quick-account/index.vue?vue&type=script&lang=js&






/* harmony default export */ var quick_accountvue_type_script_lang_js_ = ({
  name: "QuickAccount",
  components: {
    QuickLogin: quick_login,
    AccountLogin: account_login,
    "wd-button": button_default.a,
    "wd-dialog": dialog_default.a
  },
  props: {
    // 成功之后调用的函数， 优先级高级nextUrl
    successToTask: {
      type: Function,
      default: () => true
    },
    // 定路由跳转的URL
    nextUrl: {
      type: [String, Function],
      default: "/list/"
    },
    // 是否同意用户协议
    accepted: {
      type: Boolean,
      default: false
    },
    initType: {
      type: String,
      default: "quick-login"
    }
  },
  data() {
    return {
      isQuick: this.initType === "quick-login" // 是否是快速登录
    };
  },

  computed: {},
  watch: {
    initType(val) {
      this.isQuick = val === "quick-login";
    }
  },
  methods: {
    chooseType(flag) {
      this.isQuick = flag;
    },
    dealAgreement(flag) {
      this.$emit("dealAgreement", flag);
    },
    forgetPwd(flag) {
      this.$emit("forgetPwd", flag);
    },
    // 登录成功回调
    loginSuccess(val) {
      this.$emit("loginSuccess", val);
    }
  }
});
// CONCATENATED MODULE: ./packages/login-component/src/quick-account/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_quick_accountvue_type_script_lang_js_ = (quick_accountvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/quick-account/index.vue?vue&type=style&index=0&id=0ff1c200&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/login-component/src/quick-account/index.vue?vue&type=style&index=0&id=0ff1c200&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/login-component/src/quick-account/index.vue






/* normalize component */

var quick_account_component = Object(componentNormalizer["a" /* default */])(
  src_quick_accountvue_type_script_lang_js_,
  quick_accountvue_type_template_id_0ff1c200_scoped_true_render,
  quick_accountvue_type_template_id_0ff1c200_scoped_true_staticRenderFns,
  false,
  null,
  "0ff1c200",
  null
  
)

/* harmony default export */ var quick_account = (quick_account_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/wx-login/index.vue?vue&type=template&id=ef7df652&scoped=true&
var wx_loginvue_type_template_id_ef7df652_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: [`wx-login ${_vm.logoType}`] }, [
    _vm.openType == "spsspro"
      ? _c("div", { staticClass: "open-type" }, [
          _vm._m(0),
          _vm._v(
            "\n        问卷网可以帮助收集提供SPSSPRO分析的数据，您扫码授权后便可登录使用\n    "
          )
        ])
      : _c(
          "div",
          { staticClass: "title" },
          [
            _vm.logoType !== "new-logo"
              ? [
                  _c("i", { staticClass: "wx-icon" }),
                  _vm._v(" 扫码关注「问卷网」并登录\n        ")
                ]
              : [
                  _c("span", { staticClass: "new-logo-title" }, [
                    _vm._v("\n                微信扫码登录\n            ")
                  ])
                ]
          ],
          2
        ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.isOnLogin,
            expression: "isOnLogin"
          }
        ],
        staticClass: "qrcode",
        class: _vm.openType ? "open-type-qrcode" : ""
      },
      [
        _c("div", { staticClass: "qrcode-box" }, [
          _vm.isLoading
            ? _c("div", { staticClass: "loading-box" }, [
                _c("span", { staticClass: "loading-icon" }),
                _vm._v(" "),
                _c("span", { staticClass: "loading-txt" }, [
                  _vm._v("加载中...")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("section", {
            staticClass: "img-wrap",
            attrs: { id: "weixin-login-id" }
          })
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "new-logo_foottext" })
  ])
}
var wx_loginvue_type_template_id_ef7df652_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("img", {
        staticClass: "person-logo",
        attrs: {
          width: "101",
          src: "https://s1.wenjuan.com/assets/images/logo/with-text-blue.svg",
          alt: "问卷网_网络调查平台，问卷调查，报名表、考试测验"
        }
      }),
      _vm._v("\n            专业易用的调研工具\n        ")
    ])
  }
]
wx_loginvue_type_template_id_ef7df652_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/login-component/src/wx-login/index.vue?vue&type=template&id=ef7df652&scoped=true&

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(1);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./src/http/new-login/wx-login.js

let request = external_vue_default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

/**
 * 获取微信Ticket
 * @returns
 */
function httpWXTicket() {
  request = external_vue_default.a.prototype.commonRequest;
  return request.get("/auth/weixin_ticket/");
}

/**
 * 检查是否登录成功
 */
function httpLoginStatus() {
  request = external_vue_default.a.prototype.commonRequest;
  return request.post("/api/member/thirdpart/weixin/check_login_success/");
}

/**
 * 微信新用户同意用户协议后，调用此接口进行注册
 * @param {object} params
 * @returns
 */
function httpWXRegister(params) {
  request = external_vue_default.a.prototype.commonRequest;
  return request.post("/api/member/thirdpart/register/account_info/", params);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/wx-login/index.vue?vue&type=script&lang=js&


/* harmony default export */ var wx_loginvue_type_script_lang_js_ = ({
  name: "WXLogin",
  inject: ["appendParamsFn"],
  props: {
    logoType: {
      type: String,
      default: "old-logo"
    },
    nextUrl: {
      type: [String, Function, Object],
      default: "/list"
    },
    // 弹框来源，（用于记录打开登录弹框的位置，埋点等）
    source: {
      type: String,
      default: ""
    },
    isAccepted: {
      type: Boolean,
      default: false
    },
    // 成功之后调用回调函数
    success: {
      type: Function,
      default: null
    },
    // spsspro
    openType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isLoading: true,
      wxQRCode: "",
      timer: null,
      qrCodeTimer: null,
      isExpire: false,
      userInfo: null,
      wexinConf: null,
      weixinQrCodeList: [{
        label: "wxtest01",
        id: "wx04ea4f0aeee54fde",
        http: "https://wxtest01.wenjuan.com/api/member/thirdpart/weixin/auth_login/"
      }, {
        label: "ios1",
        id: "wxe16e7b5c9d42874a",
        http: "https://ios1.wenjuan.com/api/member/thirdpart/weixin/auth_login/"
      }, {
        label: "问卷网平台（网站）",
        id: "wx02df6b290641bfec",
        http: `/api/member/thirdpart/weixin/auth_login/`
      }],
      currnetQrcode: {
        label: "问卷网平台（网站）",
        id: "wx02df6b290641bfec",
        http: `/api/member/thirdpart/weixin/auth_login/`
      },
      sessionid: "",
      isOnLogin: true
    };
  },
  watch: {
    isAccepted(val) {
      if (val) {
        this.doRegister(this.userInfo);
      }
    }
  },
  mounted() {
    this.init();
    this.importWexinLoginToken();
  },
  beforeDestroy() {
    clearTimeout(this.qrCodeTimer);
    clearInterval(this.timer);
  },
  methods: {
    init() {
      this.getWXTicket();
      this.qrCodeTimer = setTimeout(() => {
        this.isExpire = true;
        clearTimeout(this.qrCodeTimer);
        clearInterval(this.timer);
      }, 600000);
      this.getLoginStatus();
      this.timer = setInterval(this.getLoginStatus, 2000);
    },
    async getWXTicket() {
      // const { data } = await httpWXTicket();
      // this.wxQRCode = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${data.ticket}`;
      this.isLoading = false;
      this.isExpire = false;
    },
    getLoginStatus() {
      httpLoginStatus().then(res => {
        const {
          data
        } = res;
        if (!this.getLoginStatus.once) {
          this.getLoginStatus.once = true;
          this.sessionid = data.session_id || "";
          this.isOnLogin = false;
          setTimeout(this.task, 500);
        }
        if (data.is_new_member) {
          this.userInfo = data.user_info_detail;
          clearInterval(this.timer);
          this.$emit("doAgree", true);
          return;
        }
        if (data.login_success) {
          this.isOnLogin = true;
          const params = data.user_info_detail;
          this.doRegister(params);
        }
      }).catch(err => {
        var _err$data;
        if (((_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.err_code) === 300004) {
          // clearInterval(this.timer);
          // this.refreshQRCode();
          const userName = err.data.err_details.username;
          window.location.href = `/nologin?username=${userName}`;
        }
      });
    },
    // 第三方登入接口
    doRegister(params) {
      this.appendParamsFn(params);
      httpWXRegister(params).then(async res => {
        if (res.data.weixin_login_success) {
          clearInterval(this.timer);
          setLastLoginType("wx-login");
          this.$emit("loginSuccess", "wx-login");
          typeof this.nextUrl === "function" ? await this.nextUrl() : this.nextUrl && (window.location.href = this.nextUrl);
          this.success && this.success();
        }
      });
    },
    refreshQRCode() {
      this.init();
    },
    task() {
      try {
        const cssCode = encodeURIComponent("LmltcG93ZXJCb3ggLnRpdGxlLC5pbXBvd2VyQm94IC5pbmZvewogICBkaXNwbGF5Om5vbmUKfQoud3JwX2NvZGV7CiB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoOTZweCk7Cn0KLmltcG93ZXJCb3ggLnFyY29kZXsKICAgICAgICB3aWR0aDogMTgwcHg7CiAgICAgICAgaGVpZ2h0OiAxODBweDsKICAgICAgICBib3JkZXI6bm9uZTsKfQo=");
        const useUrl = `${this.source === "answer" ? "https://www.wenjuan.com" : this.currnetQrcode.http.startsWith("http") ? "" : window.location.origin}${this.currnetQrcode.http}?session_id=${this.sessionid}`;
        const redirect_uri = encodeURIComponent(useUrl);

        // eslint-disable-next-line no-undef
        window.wexinConf = new WxLogin({
          self_redirect: true,
          id: "weixin-login-id",
          response_type: "code",
          appid: this.currnetQrcode.id,
          scope: "snsapi_login",
          redirect_uri,
          state: "STATE",
          // style: "",
          href: `data:text/css;base64,${cssCode}`
        });
        window.wexinConf.__url__ = useUrl;
        console.log("微信login创建成功");
      } catch (e) {
        console.log("微信login创建失败", e);
      }
    },
    // 引入第三方微信授权登入插件
    importWexinLoginToken() {
      const createDom = (() => {
        try {
          const wexinSrc = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
          const s = document.createElement("script");
          s.src = wexinSrc;
          s.type = "text/javascript";
          s.onload = () => {
            createDom.catch(e => this.$message(new Error("微信sdk 引入失败"))).then(() => {
              console.log("引入登成功");
            });
          };
          document.body.appendChild(s);
          return Promise.resolve();
        } catch (e) {
          return Promise.reject();
        }
      })();
    }
  }
});
// CONCATENATED MODULE: ./packages/login-component/src/wx-login/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_wx_loginvue_type_script_lang_js_ = (wx_loginvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/wx-login/index.vue?vue&type=style&index=0&id=ef7df652&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/login-component/src/wx-login/index.vue?vue&type=style&index=0&id=ef7df652&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/login-component/src/wx-login/index.vue






/* normalize component */

var wx_login_component = Object(componentNormalizer["a" /* default */])(
  src_wx_loginvue_type_script_lang_js_,
  wx_loginvue_type_template_id_ef7df652_scoped_true_render,
  wx_loginvue_type_template_id_ef7df652_scoped_true_staticRenderFns,
  false,
  null,
  "ef7df652",
  null
  
)

/* harmony default export */ var wx_login = (wx_login_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/third-party/index.vue?vue&type=template&id=5aa32d49&scoped=true&
var third_partyvue_type_template_id_5aa32d49_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "third-party-wrap" },
    [
      _c("div", { staticClass: "third-party-blk" }, [
        !_vm.showMore
          ? _c("div", { staticClass: "partial-box" }, [
              _vm.initType === "wx-login"
                ? _c("span", { staticClass: "login-type" }, [
                    _c("span", {
                      staticClass: "login-icon phone",
                      on: {
                        click: function($event) {
                          return _vm.$emit("change", "quick-login")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "login-name phone-email" }, [
                      _vm._v("手机/邮箱")
                    ])
                  ])
                : _c("span", { staticClass: "login-type" }, [
                    _c("span", {
                      staticClass: "login-icon wx",
                      on: {
                        click: function($event) {
                          return _vm.$emit("change", "wx-login")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "login-name" }, [_vm._v("微信")])
                  ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "login-type",
                  on: {
                    click: function($event) {
                      return _vm.handleCommonLogin("qq")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "login-icon qq" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "login-name" }, [_vm._v("QQ")])
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "login-type" }, [
                _c("span", {
                  staticClass: "login-icon more",
                  on: { click: _vm.handleShowMore }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "login-name" }, [_vm._v("更多")])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showMore
          ? _c(
              "div",
              { staticClass: "all-box" },
              [
                _vm.initType === "wx-login"
                  ? _c("span", { staticClass: "login-type" }, [
                      _c("span", {
                        staticClass: "login-icon phone",
                        on: {
                          click: function($event) {
                            return _vm.$emit("change", "quick-login")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "login-name" }, [
                        _vm._v("手机")
                      ])
                    ])
                  : _c("span", { staticClass: "login-type" }, [
                      _c("span", {
                        staticClass: "login-icon wx",
                        on: {
                          click: function($event) {
                            return _vm.$emit("change", "wx-login")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "login-name" }, [
                        _vm._v("微信")
                      ])
                    ]),
                _vm._v(" "),
                _vm._l(_vm.list, function(item, index) {
                  return _c(
                    "span",
                    {
                      key: index,
                      staticClass: "login-type",
                      on: {
                        click: function($event) {
                          return _vm.handleCommonLogin(item.type)
                        }
                      }
                    },
                    [
                      _c("span", { class: ["login-icon", item.icon] }),
                      _vm._v(" "),
                      _c("span", { staticClass: "login-name" }, [
                        _vm._v(_vm._s(item.name))
                      ])
                    ]
                  )
                })
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var third_partyvue_type_template_id_5aa32d49_scoped_true_staticRenderFns = []
third_partyvue_type_template_id_5aa32d49_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/login-component/src/third-party/index.vue?vue&type=template&id=5aa32d49&scoped=true&

// CONCATENATED MODULE: ./src/http/new-login/third-party-login.js

let third_party_login_request = external_vue_default.a.prototype.commonRequest;
if (!third_party_login_request || !third_party_login_request.get || !third_party_login_request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

/**
 * 获取qq登录url
 * @returns
 */
function httpQQLoginURL() {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.get("/api/member/thirdpart/qq/authorize/");
}

/**
 * 检查qq登录是否成功
 * @returns
 */
function httpQQLoginStatus() {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.post("/api/member/thirdpart/qq/check_login_success/");
}

/**
 * qq新用户同意用户协议后，调用此接口进行注册
 * @param {object} params
 * @returns
 */
function httpQQRegister(params) {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.post("/api/member/thirdpart/qq/login/", params);
}

/**
 * 获取企业微信登录url
 * @returns
 */
function httpEntWXLoginURL() {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.get("/api/member/third_part/business_weixin/authorize/");
}

/**
 * 检查企业微信登录是否成功
 * @returns
 */
function httpEntWXLoginStatus() {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.get("/api/member/third_part/business_weixin/check_login/");
}

/**
 * 企业微信新用户同意用户协议后，调用此接口进行注册
 * @param {object} params
 * @returns
 */
function httpEntWXRegister(params) {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.post("/api/member/third_part/business_weixin/register/", params);
}

/**
 * 获取钉钉登录url
 * @returns
 */
function httpDingDingLoginURL() {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.get("/api/member/third_part/dingtalk/authorize/");
}

/**
 * 检查钉钉登录是否成功
 * @returns
 */
function httpDingDingLoginStatus() {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.get("/api/member/third_part/dingtalk/check_login/");
}

/**
 * 钉钉新用户同意用户协议后，调用此接口进行注册
 * @param {object} params
 * @returns
 */
function httpDingDingRegister(params) {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.post("/api/member/third_part/dingtalk/register/", params);
}

/**
 * 获取飞书登录url
 * @returns
 */
function httpFeishuLoginURL() {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.get("/api/member/thirdpart/feishu/authorization_url/");
}

/**
 * 检查飞书登录是否扫码
 * @returns
 */
function httpFeishuScanStatus() {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.get("/api/member/thirdpart/feishu/check_login/");
}

/**
 * 检查飞书登录是否成功
 * @param {object} params
 * @returns
 */
function httpFeishuLoginStatus(params) {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.post("/api/member/thirdpart/feishu/login/", params);
}

/**
 * 获取微博登录url
 * @returns
 */
function httpWeiboLoginURL() {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.get("/api/member/third_part/sina/authorize/");
}

/**
 * 检查微博登录是否成功
 * @returns
 */
function httpWeiboLoginStatus() {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.get("/api/member/third_part/sina/check_login/");
}

/**
 * 微博新用户同意用户协议后，调用此接口进行注册
 * @param {object} params
 * @returns
 */
function httpWeiboRegister(params) {
  third_party_login_request = external_vue_default.a.prototype.commonRequest;
  return third_party_login_request.post("/api/member/third_part/sina/register/", params);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/third-party/index.vue?vue&type=script&lang=js&




/* harmony default export */ var third_partyvue_type_script_lang_js_ = ({
  name: "ThirdParty",
  components: {},
  inject: ["appendParamsFn"],
  props: {
    initType: {
      type: String,
      default: "wx-login"
    },
    nextUrl: {
      type: [String, Function, Object],
      default: "/list"
    },
    isAccepted: {
      type: Boolean,
      default: false
    },
    // 成功之后调用回调函数
    success: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      list: [{
        type: "qq",
        name: "QQ",
        icon: "qq"
      }, {
        type: "weibo",
        name: "微博",
        icon: "weibo"
      }, {
        type: "ent_wx",
        name: "企微",
        icon: "ent-wx"
      }, {
        type: "dingding",
        name: "钉钉",
        icon: "ding"
      }, {
        type: "feishu",
        name: "飞书",
        icon: "feishu"
      }],
      showMore: false,
      timer: null,
      loginType: "",
      isNewUser: false,
      qqUserInfo: null,
      weiboUserInfo: null,
      dingdingUserInfo: null,
      entWXUserInfo: null,
      feishuUserInfo: null
    };
  },
  watch: {
    isAccepted(val) {
      if (val) {
        this.handleRegister();
      }
    }
  },
  methods: {
    handleShowMore() {
      this.showMore = true;
    },
    async handleCommonLogin(loginType) {
      this.loginType = loginType;
      this.$emit("iconClick", true);
      let res = null;
      switch (loginType) {
        case "qq":
          res = await httpQQLoginURL();
          this.openWin(res.data.qq_request_url);
          this.intervalLoginStatus(this.getQQLoginStatus);
          break;
        case "ent_wx":
          res = await httpEntWXLoginURL();
          this.openWin(res.data.authorize_url);
          this.intervalLoginStatus(this.getEntWXLoginStatus);
          break;
        case "dingding":
          res = await httpDingDingLoginURL();
          this.openWin(res.data.authorize_url);
          this.intervalLoginStatus(this.getDingDingLoginStatus);
          break;
        case "feishu":
          res = await httpFeishuLoginURL();
          this.openWin(res.data.feishu_url);
          this.intervalLoginStatus(this.getFeishuLoginStatus);
          break;
        case "weibo":
          res = await httpWeiboLoginURL();
          this.openWin(res.data.authorize_url);
          this.intervalLoginStatus(this.getWeiboLoginStatus);
          break;
        default:
          break;
      }
    },
    async getQQLoginStatus() {
      const response = await httpQQLoginStatus().catch(err => {
        if (err.data.err_code === 300004) {
          this.handleStopClose();
          const userName = err.data.err_details.username;
          window.location.href = `/nologin?username=${userName}`;
        }
      });
      if (!response) {
        return;
      }
      const {
        data
      } = response;
      if (data.is_new_member) {
        this.isNewUser = true;
        this.qqUserInfo = data.user_info_detail;
        this.closeWin();
        this.$emit("doAgree", true);
        return;
      }
      if (data.login_success) {
        this.appendParamsFn(data.user_info_detail);
        httpQQRegister(data.user_info_detail).then(res => {
          if (res.data.qq_login_success) {
            this.closeWinAndJump();
          }
        });
      }
    },
    async getEntWXLoginStatus() {
      const res = await httpEntWXLoginStatus().catch(err => {
        if (err.data.err_code === 300004) {
          this.handleStopClose();
          const userName = err.data.err_details.username;
          window.location.href = `/nologin?username=${userName}`;
        }
      });
      if (!res) {
        return;
      }
      const {
        data
      } = res;
      // 状态码为1时继续轮询，为0时登陆成功，其他则停止轮询，关闭窗口，提示错误信息
      if (data.login_status !== 0 && data.login_status !== 1) {
        message_default.a.error(data.message);
        this.handleStopClose();
        return;
      }
      if (data.user) {
        this.isNewUser = true;
        this.entWXUserInfo = data.user;
        this.closeWin();
        this.$emit("doAgree", true);
        return;
      }
      if (data.login_status === 0) {
        this.closeWinAndJump();
      }
    },
    async getDingDingLoginStatus() {
      const res = await httpDingDingLoginStatus().catch(err => {
        if (err.data.err_code === 300004) {
          this.handleStopClose();
          const userName = err.data.err_details.username;
          window.location.href = `/nologin?username=${userName}`;
        }
      });
      if (!res) {
        return;
      }
      const {
        data
      } = res;
      // 状态码为1时继续轮询，为0时登陆成功，其他则停止轮询，关闭窗口，提示错误信息
      if (data.login_status !== 0 && data.login_status !== 1) {
        message_default.a.error(data.message);
        this.handleStopClose();
        return;
      }
      if (data.dingtalk_user) {
        this.isNewUser = true;
        this.dingdingUserInfo = data.dingtalk_user;
        this.closeWin();
        this.$emit("doAgree", true);
        return;
      }
      if (data.login_status === 0) {
        this.closeWinAndJump();
      }
    },
    async getFeishuLoginStatus() {
      const response = await httpFeishuScanStatus().catch(err => {
        if (err.data.err_code === 300004) {
          this.handleStopClose();
          const userName = err.data.err_details.username;
          window.location.href = `/nologin?username=${userName}`;
        }
        if (err.data.err_code === 220001) {
          this.handleStopClose();
        }
      });
      if (!response) {
        return;
      }
      const {
        data
      } = response;
      // 是否已扫码
      if (!data.scan_success) {
        return;
      }
      // 新用户
      if (data.is_new_member) {
        this.isNewUser = true;
        this.feishuUserInfo = {
          code: data.code,
          agree_agreement: true
        };
        this.closeWin();
        this.$emit("doAgree", true);
        return;
      }
      // 老用户
      if (!data.is_new_member) {
        httpFeishuLoginStatus({
          code: data.code,
          member_id: data.member_id
        }).then(res => {
          if (res.data.is_login) {
            this.closeWinAndJump();
          }
        });
      }
    },
    async getWeiboLoginStatus() {
      const res = await httpWeiboLoginStatus().catch(err => {
        if (err.data.err_code === 300004) {
          this.handleStopClose();
          const userName = err.data.err_details.username;
          window.location.href = `/nologin?username=${userName}`;
        }
      });
      if (!res) {
        return;
      }
      const {
        data
      } = res;
      if (data.is_new) {
        this.isNewUser = true;
        this.weiboUserInfo = data.user_info;
        this.$emit("doAgree", true);
        this.closeWin();
        return;
      }
      if (data.login_status === 0) {
        this.closeWinAndJump();
      }
    },
    intervalLoginStatus(getLoginStatus) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (window.thirdPartyLoginWin && window.thirdPartyLoginWin.closed) {
          clearInterval(this.timer);
          return;
        }
        getLoginStatus();
      }, 2000);
    },
    openWin(url) {
      const width = 754;
      const height = 562;
      const left = window.screen.availWidth / 2 - width / 2;
      const top = window.screen.availHeight / 2 - height / 2;
      const openTimer = setTimeout(() => {
        clearTimeout(openTimer);
        window.thirdPartyLoginWin = window.open(url, "thirdPartyWin", `width=${width}, height=${height}, left=${left}, top=${top}`);
      }, 200);
    },
    closeWin() {
      window.thirdPartyLoginWin.close();
    },
    async closeWinAndJump() {
      clearInterval(this.timer);
      window.thirdPartyLoginWin.close();
      setLastLoginType("wx-login");
      this.$emit("loginSuccess", "third-part");
      typeof this.nextUrl === "function" ? await this.nextUrl() : this.nextUrl && (window.location.href = this.nextUrl);
      this.success && this.success();
    },
    handleRegister() {
      const params = {};
      this.appendParamsFn(params);
      switch (this.loginType) {
        case "qq":
          httpQQRegister({
            ...this.qqUserInfo,
            ...params
          }).then(res => {
            if (res.data.qq_login_success) {
              this.closeWinAndJump();
            }
          });
          break;
        case "ent_wx":
          httpEntWXRegister({
            ...params,
            ...this.entWXUserInfo
          }).then(res => {
            if (res.data.register_status) {
              this.closeWinAndJump();
            }
          });
          break;
        case "dingding":
          httpDingDingRegister({
            ...params,
            ...this.dingdingUserInfo
          }).then(res => {
            if (res.data.register_status) {
              this.closeWinAndJump();
            }
          });
          break;
        case "weibo":
          httpWeiboRegister({
            ...params,
            sina_register_info: this.weiboUserInfo
          }).then(res => {
            if (res.data.register_status) {
              this.closeWinAndJump();
            }
          });
          break;
        case "feishu":
          httpFeishuLoginStatus({
            ...params,
            ...this.feishuUserInfo
          }).then(res => {
            if (res.data.is_login) {
              this.closeWinAndJump();
            }
          });
          break;
        default:
          break;
      }
    },
    handleStopClose() {
      clearInterval(this.timer);
      window.thirdPartyLoginWin.close();
    }
  }
});
// CONCATENATED MODULE: ./packages/login-component/src/third-party/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_third_partyvue_type_script_lang_js_ = (third_partyvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/third-party/index.vue?vue&type=style&index=0&id=5aa32d49&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/login-component/src/third-party/index.vue?vue&type=style&index=0&id=5aa32d49&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/login-component/src/third-party/index.vue






/* normalize component */

var third_party_component = Object(componentNormalizer["a" /* default */])(
  src_third_partyvue_type_script_lang_js_,
  third_partyvue_type_template_id_5aa32d49_scoped_true_render,
  third_partyvue_type_template_id_5aa32d49_scoped_true_staticRenderFns,
  false,
  null,
  "5aa32d49",
  null
  
)

/* harmony default export */ var third_party = (third_party_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/agreement.vue?vue&type=template&id=3f918ec0&scoped=true&
var agreementvue_type_template_id_3f918ec0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "agreement-component" }, [
    _c("h3", { staticClass: "agree-title" }, [
      _vm._v("用户服务协议及隐私政策")
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "btn-part" },
      [
        _c(
          "wd-button",
          {
            attrs: { type: "secondary btn-162" },
            on: {
              click: function($event) {
                return _vm.agreeOrNot(false)
              }
            }
          },
          [_vm._v("不同意")]
        ),
        _vm._v(" "),
        _c(
          "wd-button",
          {
            attrs: { type: "primary btn-162" },
            on: {
              click: function($event) {
                return _vm.agreeOrNot(true)
              }
            }
          },
          [_vm._v("同意")]
        )
      ],
      1
    )
  ])
}
var agreementvue_type_template_id_3f918ec0_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "word-section" }, [
      _vm._v(
        "\n        感谢您信任并使用问卷网提供的在线调研服务，我们非常重视您的个人信息和隐私保护。依照最新法律要求，我们制定了用户协议、隐私政策，请您务必仔细阅读"
      ),
      _c(
        "a",
        {
          staticClass: "link",
          attrs: { href: "/register/protocol", target: "_blank" }
        },
        [_vm._v("《问卷网服务协议》")]
      ),
      _vm._v("及"),
      _c(
        "a",
        {
          staticClass: "link",
          attrs: { href: "/about/ystk", target: "_blank" }
        },
        [_vm._v("《隐私政策》")]
      ),
      _vm._v(
        "，并确认了解我们对您个人信息的处理规则，包括我们会收集您个人信息的类型、我们如何收集、使用、储存您的个人信息，以及您所拥有的各项权利等事项。"
      ),
      _c("br"),
      _vm._v(
        "\n        如果您是未满18周岁的未成年人，请您通知您的监护人共同阅读上述材料。\n    "
      )
    ])
  }
]
agreementvue_type_template_id_3f918ec0_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/login-component/src/agreement.vue?vue&type=template&id=3f918ec0&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/agreement.vue?vue&type=script&lang=js&


/* harmony default export */ var agreementvue_type_script_lang_js_ = ({
  name: "Agreement",
  components: {
    "wd-button": button_default.a
  },
  props: {
    token: {
      type: String,
      default: ""
    },
    isThird: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    agreeOrNot(flag) {
      if (this.isThird) {
        this.$emit("thirdAgreed", flag);
      } else {
        this.$emit("agreed", flag);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/login-component/src/agreement.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_agreementvue_type_script_lang_js_ = (agreementvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/agreement.vue?vue&type=style&index=0&id=3f918ec0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/login-component/src/agreement.vue?vue&type=style&index=0&id=3f918ec0&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/login-component/src/agreement.vue






/* normalize component */

var agreement_component = Object(componentNormalizer["a" /* default */])(
  src_agreementvue_type_script_lang_js_,
  agreementvue_type_template_id_3f918ec0_scoped_true_render,
  agreementvue_type_template_id_3f918ec0_scoped_true_staticRenderFns,
  false,
  null,
  "3f918ec0",
  null
  
)

/* harmony default export */ var agreement = (agreement_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/retrieve.vue?vue&type=template&id=4ae7ef57&scoped=true&
var retrievevue_type_template_id_4ae7ef57_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "retrieve-component" }, [
    _vm.isCheckingPage
      ? _c(
          "div",
          { staticClass: "check-content" },
          [
            _c("div", { staticClass: "check-header" }, [
              _c(
                "div",
                {
                  class:
                    _vm.checkMethod === "mobile"
                      ? "header-common selected"
                      : "header-common notSelected",
                  on: {
                    click: function($event) {
                      return _vm.handleSelect("mobile")
                    }
                  }
                },
                [_vm._v("\n                手机找回\n            ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class:
                    _vm.checkMethod === "email"
                      ? "header-common selected"
                      : "header-common notSelected",
                  on: {
                    click: function($event) {
                      return _vm.handleSelect("email")
                    }
                  }
                },
                [_vm._v("\n                邮箱找回\n            ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "slider-container" }, [
              _c("div", {
                class:
                  _vm.checkMethod === "mobile"
                    ? "slider-box slider-left"
                    : "slider-box slider-right"
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.checkMethod === "mobile",
                    expression: "checkMethod === 'mobile'"
                  }
                ],
                staticClass: "check-form"
              },
              [
                _c("ComplexInput", {
                  ref: "MobileComplexInput",
                  attrs: {
                    "is-error": _vm.phoneError,
                    "is-active": _vm.canSendPhoneCode,
                    maxlength: _vm.phoneObj.preValue == 86 ? 11 : 15,
                    start: _vm.sendPhoneCode
                  },
                  on: {
                    input: _vm.phoneInput,
                    blur: _vm.phoneBlur,
                    checkValue: _vm.areaSelect,
                    stop: _vm.MobileCountDownStop
                  },
                  model: {
                    value: _vm.phoneObj,
                    callback: function($$v) {
                      _vm.phoneObj = $$v
                    },
                    expression: "phoneObj"
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.phoneError,
                        expression: "phoneError"
                      }
                    ],
                    staticClass: "error-msg"
                  },
                  [_vm._v(_vm._s(_vm.phoneErrorMsg))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "code" },
                  [
                    _c("Captcha", {
                      ref: "phoneCaptcha",
                      attrs: {
                        "error-all": _vm.phoneCodeError,
                        "stop-back-error": "",
                        "auto-error": false
                      },
                      on: {
                        end: _vm.phoneCodeEnd,
                        blur: _vm.phoneCodeBlur,
                        focus: _vm.phoneCodeFocus
                      },
                      model: {
                        value: _vm.phoneCode,
                        callback: function($$v) {
                          _vm.phoneCode = $$v
                        },
                        expression: "phoneCode"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.phoneCodeErrorMsg,
                        expression: "phoneCodeErrorMsg"
                      }
                    ],
                    staticClass: "error-msg"
                  },
                  [_vm._v(_vm._s(_vm.phoneCodeErrorMsg))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.checkMethod === "email",
                    expression: "checkMethod === 'email'"
                  }
                ],
                staticClass: "check-form"
              },
              [
                _c(
                  "div",
                  { staticClass: "email-input" },
                  [
                    _c(
                      "wd-input",
                      {
                        attrs: {
                          "is-error": _vm.emailError,
                          placeholder: "请输入邮箱"
                        },
                        on: { input: _vm.emailInput, blur: _vm.emailBlur },
                        model: {
                          value: _vm.emailValue,
                          callback: function($$v) {
                            _vm.emailValue = $$v
                          },
                          expression: "emailValue"
                        }
                      },
                      [
                        _vm._t(
                          "append",
                          function() {
                            return [
                              _c("Countdown", {
                                ref: "EmailCountdown",
                                attrs: {
                                  slot: "append",
                                  "is-active": _vm.canSendEmailCode,
                                  text: _vm.emailCountdownText,
                                  start: _vm.sendEmailCode
                                },
                                on: { stop: _vm.EmailCountDownStop },
                                slot: "append"
                              })
                            ]
                          },
                          { slot: "append" }
                        )
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.emailError,
                        expression: "emailError"
                      }
                    ],
                    staticClass: "error-msg"
                  },
                  [_vm._v(_vm._s(_vm.emailErrorMsg))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "code" },
                  [
                    _c("Captcha", {
                      ref: "emailCaptcha",
                      attrs: {
                        "error-all": _vm.emailCodeError,
                        "stop-back-error": "",
                        "auto-error": false
                      },
                      on: {
                        end: _vm.emailCodeEnd,
                        blur: _vm.emailCodeBlur,
                        focus: _vm.emailCodeFocus
                      },
                      model: {
                        value: _vm.emailCode,
                        callback: function($$v) {
                          _vm.emailCode = $$v
                        },
                        expression: "emailCode"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.emailCodeErrorMsg,
                        expression: "emailCodeErrorMsg"
                      }
                    ],
                    staticClass: "error-msg"
                  },
                  [_vm._v(_vm._s(_vm.emailCodeErrorMsg))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "wd-button",
              {
                staticClass: "next-button",
                class: _vm.nextDisabled ? "next-disabled" : "",
                attrs: {
                  type: _vm.nextDisabled ? "info" : "primary",
                  disabled: _vm.nextDisabled
                },
                on: { click: _vm.handleNext }
              },
              [_vm._v("下一步")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "footer" }, [
              _c(
                "a",
                {
                  staticClass: "left",
                  attrs: { target: "_blank", href: "/s/UZBZJvTiJW/" }
                },
                [
                  _vm._v(
                    _vm._s(
                      (_vm.checkMethod === "mobile" ? "手机号" : "邮箱") +
                        "不可用"
                    )
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "right", on: { click: _vm.loginBack } },
                [_vm._v("返回登录")]
              )
            ])
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "setting-content" },
          [
            _c("div", { staticClass: "set-back" }, [
              _c(
                "div",
                { staticClass: "back-button", on: { click: _vm.handleBack } },
                [
                  _c("i", { staticClass: "back-svg" }),
                  _vm._v("返回\n            ")
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "set-title" }, [_vm._v("设置密码")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "password-input" },
              [
                _c("wd-input", {
                  attrs: {
                    "is-error": _vm.passwordError,
                    placeholder: "请输入密码",
                    "show-password": "",
                    oncopy: "return false",
                    oncut: "return false"
                  },
                  on: { input: _vm.passwordInput, blur: _vm.passwordBlur },
                  model: {
                    value: _vm.newPasswordValue,
                    callback: function($$v) {
                      _vm.newPasswordValue = $$v
                    },
                    expression: "newPasswordValue"
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.passwordError,
                        expression: "passwordError"
                      }
                    ],
                    staticClass: "error-msg"
                  },
                  [_vm._v(_vm._s(_vm.passwordErrorMsg))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "password-input" },
              [
                _c("wd-input", {
                  attrs: {
                    "is-error": _vm.confirmError,
                    placeholder: "请再次输入密码",
                    "show-password": "",
                    oncopy: "return false",
                    oncut: "return false"
                  },
                  on: { input: _vm.confirmInput, blur: _vm.confirmBlur },
                  model: {
                    value: _vm.confirmPasswordValue,
                    callback: function($$v) {
                      _vm.confirmPasswordValue = $$v
                    },
                    expression: "confirmPasswordValue"
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.confirmError,
                        expression: "confirmError"
                      }
                    ],
                    staticClass: "error-msg"
                  },
                  [_vm._v(_vm._s(_vm.confirmErrorMsg))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "wd-button",
              {
                staticClass: "finish-button",
                class: _vm.completeDisabled ? "finish-disabled" : "",
                attrs: {
                  type: _vm.completeDisabled ? "info" : "primary",
                  disabled: _vm.completeDisabled
                },
                on: { click: _vm.handleFinish }
              },
              [_vm._v("完成")]
            )
          ],
          1
        )
  ])
}
var retrievevue_type_template_id_4ae7ef57_scoped_true_staticRenderFns = []
retrievevue_type_template_id_4ae7ef57_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/login-component/src/retrieve.vue?vue&type=template&id=4ae7ef57&scoped=true&

// EXTERNAL MODULE: ./packages/complex-input/src/countdown.vue + 6 modules
var countdown = __webpack_require__(33);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/retrieve.vue?vue&type=script&lang=js&











/* harmony default export */ var retrievevue_type_script_lang_js_ = ({
  components: {
    "wd-button": button_default.a,
    "wd-input": input_default.a,
    ComplexInput: src_complex_input["a" /* default */],
    Countdown: countdown["a" /* default */],
    Captcha: captcha["default"]
  },
  data() {
    return {
      checkMethod: "mobile",
      // 默认选中手机端
      isCheckingPage: true,
      // 验证手机号/邮箱界面
      checkingPass: true,
      // 下一步校验通过
      canSendPhoneCode: false,
      // 可发送手机验证码
      canSendEmailCode: false,
      // 可发送邮箱验证码
      canClickPhoneCode: true,
      // 发送手机验证码可点击响应
      canClickEmailCode: true,
      // 发送邮箱验证码可点击响应
      phoneError: false,
      // 手机号校验错误
      emailError: false,
      // 邮箱校验错误
      phoneErrorMsg: "",
      // 手机号校验错误提示
      emailErrorMsg: "",
      // 邮箱校验错误提示
      phoneCode: "",
      // 手机号验证码
      emailCode: "",
      // 邮箱验证码
      phoneCodeError: false,
      // 手机验证码错误
      emailCodeError: false,
      // 邮箱验证码错误
      phoneCodeErrorMsg: "",
      // 手机验证码错误信息
      emailCodeErrorMsg: "",
      // 邮箱验证码错误信息
      emailValue: "",
      // 邮箱绑定值
      phoneObj: {
        value: "",
        preValue: "86"
      },
      // 手机号绑定值

      newPasswordValue: "",
      // 新密码
      confirmPasswordValue: "",
      // 确认密码
      passwordError: false,
      // 密码校验错误
      confirmError: false,
      // 确认密码校验错误
      passwordErrorMsg: "",
      // 密码校验错误提示
      confirmErrorMsg: "",
      // 确认密码校验错误提示
      resetToken: "",
      // 重置密码用户身份标识
      resetType: "",
      // 重置密码类型（手机/邮箱）
      resetIdentifier: "",
      // 重置密码的手机/邮箱
      emailCountdownText: "发送验证码" // 邮箱倒计时文本
    };
  },

  computed: {
    // 下一步按钮是否可点击
    nextDisabled() {
      if (this.checkMethod === "mobile") {
        if (this.canSendPhoneCode && this.phoneCode && this.phoneCode.length === 6) {
          return false;
        }
      } else if (this.canSendEmailCode && this.emailCode && this.emailCode.length === 6) {
        return false;
      }
      return true;
    },
    // 完成按钮是否可点击
    completeDisabled() {
      if (this.newPasswordValue && this.confirmPasswordValue) {
        return false;
      }
      return true;
    }
  },
  methods: {
    // 手机号/区号输入，检查发送验证码按钮状态
    phoneInput(obj, flag) {
      this.checkCanSendPhoneCode(obj, flag);
    },
    // 手机号输入失焦，验证手机号合法性
    phoneBlur(obj) {
      if (obj.type === "areaBlur") return;
      this.checkPhoneLegal(obj);
    },
    // 下拉切换区号验证手机号合法性（会触发@input事件，无需判断按钮）
    areaSelect(obj) {
      this.checkPhoneLegal(obj);
    },
    // 检查手机号、区号是否合法
    checkPhoneLegal(obj) {
      if (!obj.value.preValue) {
        this.phoneErrorMsg = "请输入区号";
        this.phoneError = true;
      } else if (!obj.value.value) {
        this.phoneErrorMsg = "请输入手机号";
        this.phoneError = true;
      } else if (!obj.isHad) {
        this.phoneErrorMsg = "请输入有效的区号";
        this.phoneError = true;
      } else if (obj.value.preValue == 86 && !/^1[3456789]\d{9}$/.test(obj.value.value) || obj.value.preValue != 86 && (obj.value.value.length < 4 || obj.value.value.length > 15)) {
        this.phoneErrorMsg = "请输入有效的手机号";
        this.phoneError = true;
      } else {
        this.phoneError = false;
      }
    },
    // 检查是否可发送手机验证码
    checkCanSendPhoneCode(obj, flag) {
      if (obj.preValue == 86 && /^1[3456789]\d{9}$/.test(obj.value) || obj.preValue != 86 && flag && obj.value.length >= 4 && obj.value.length <= 15) {
        this.canSendPhoneCode = true;
      } else {
        this.canSendPhoneCode = false;
      }
    },
    // 发送手机验证码
    sendPhoneCode() {
      // 校验手机格式
      this.checkPhoneLegal({
        value: this.phoneObj,
        isHad: this.$refs.MobileComplexInput.getIsHad()
      });
      if (this.phoneError || !this.canClickPhoneCode) return false;
      const data = {
        identifier: `+${this.phoneObj.preValue}${this.phoneObj.value}`,
        generate_for: "retrieve_via_mobile"
      };
      this.tencentManMachineVerificatio(data, true);
    },
    // 手机发送验证码倒计时结束
    MobileCountDownStop() {
      this.canClickPhoneCode = true;
    },
    // 手机验证码重新输入完整，重置验证码错误提示
    phoneCodeEnd() {
      this.phoneCodeError = false;
      this.phoneCodeErrorMsg = "";
    },
    // 手机验证码失焦，判断验证码格式
    phoneCodeBlur(val) {
      if (!val) {
        if (!this.phoneCode) {
          this.phoneCodeError = true;
          this.phoneCodeErrorMsg = "请输入验证码";
        } else if (this.phoneCode.length > 0 || this.phoneCode.length < 6) {
          this.phoneCodeError = true;
          this.phoneCodeErrorMsg = "请输入正确的验证码";
        }
      }
    },
    // 手机验证码focus，清空报错
    phoneCodeFocus() {
      if (this.phoneCodeErrorMsg) {
        this.phoneCodeError = false;
        this.phoneCodeErrorMsg = "";
      }
    },
    // 邮箱输入，判断按钮状态
    emailInput(val) {
      this.emailValue = val.replace(/\s|[\u4E00-\u9FA5]/g, "");
      this.checkCanSendEmailCode();
    },
    // 邮箱失焦，校验邮箱格式
    emailBlur() {
      this.checkEmailLegal();
    },
    // 检查邮箱是否合法
    checkEmailLegal() {
      if (!this.emailValue) {
        this.emailErrorMsg = "请输入邮箱";
        this.emailError = true;
      } else if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.emailValue)) {
        this.emailErrorMsg = "请输入有效的邮箱";
        this.emailError = true;
      } else {
        this.emailError = false;
      }
    },
    // 检查是否可发送邮箱验证码
    checkCanSendEmailCode() {
      if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.emailValue)) {
        this.canSendEmailCode = true;
      } else {
        this.canSendEmailCode = false;
      }
    },
    // 发送邮箱验证码
    sendEmailCode() {
      this.checkEmailLegal();
      if (this.emailError || !this.canClickEmailCode) return false;
      const data = {
        identifier: this.emailValue,
        generate_for: "retrieve_via_email"
      };
      this.tencentManMachineVerificatio(data, false);
    },
    // 邮箱发送验证码倒计时结束
    EmailCountDownStop() {
      this.canClickEmailCode = true;
      this.emailCountdownText = "重新发送";
    },
    // 邮箱验证码重新输入完整，重置验证码错误提示
    emailCodeEnd() {
      this.emailCodeError = false;
      this.emailCodeErrorMsg = "";
    },
    // 手机验证码失焦，判断验证码格式
    emailCodeBlur(val) {
      if (!val) {
        if (!this.emailCode) {
          this.emailCodeError = true;
          this.emailCodeErrorMsg = "请输入验证码";
        } else if (this.emailCode.length > 0 || this.emailCode.length < 6) {
          this.emailCodeError = true;
          this.emailCodeErrorMsg = "请输入正确的验证码";
        }
      }
    },
    // 邮箱验证码focus，清空报错
    emailCodeFocus() {
      if (this.emailCodeErrorMsg) {
        this.emailCodeError = false;
        this.emailCodeErrorMsg = "";
      }
    },
    // 发送验证码并开始倒计时
    sendVerifyCode(data, isMobile) {
      Object(new_login["c" /* httpGetPhoneCode */])(data).then(res => {
        if (res.data && res.data.is_success) {
          if (isMobile) {
            this.canClickPhoneCode = false;
            // 开始倒计时
            this.$refs.MobileComplexInput.startRunTime();
            // 验证码组件聚焦
            this.$refs.phoneCaptcha.setFocus();
          } else {
            this.canClickEmailCode = false;
            // 开始倒计时
            this.$refs.EmailCountdown.startRunTime();
            // 验证码组件聚焦
            this.$refs.emailCaptcha.setFocus();
          }
        } else if (isMobile) {
          this.phoneError = true;
          this.phoneErrorMsg = res.err_msg;
        } else if (!isMobile) {
          this.emailError = true;
          this.emailErrorMsg = res.err_msg;
        }
      }).catch(err => {
        var _err$data;
        if (typeof err === "object" && (_err$data = err.data) !== null && _err$data !== void 0 && _err$data.err_msg) {
          if (isMobile) {
            var _err$data2;
            this.phoneError = true;
            this.phoneErrorMsg = (_err$data2 = err.data) === null || _err$data2 === void 0 ? void 0 : _err$data2.err_msg;
          } else if (!isMobile) {
            var _err$data3;
            this.emailError = true;
            this.emailErrorMsg = (_err$data3 = err.data) === null || _err$data3 === void 0 ? void 0 : _err$data3.err_msg;
          }
        }
        return Promise.reject(err);
      });
    },
    // 腾讯滑块验证逻辑
    tencentManMachineVerificatio(data, isMobile) {
      manMachineVerificationByTencent().then(res => {
        // 调用发送验证码接口获取验证码
        this.sendVerifyCode(data, isMobile);
      }).catch(err => {
        console.log(err, "滑块验证不通过");
      });
    },
    // 下一步至密码设置页
    handleNext() {
      let data = {
        identifier: "",
        validate_for: "",
        vcode: ""
      };
      if (this.checkMethod === "mobile") {
        this.resetIdentifier = `+${this.phoneObj.preValue}${this.phoneObj.value}`;
        data = {
          identifier: this.resetIdentifier,
          validate_for: "retrieve_via_mobile",
          vcode: this.phoneCode
        };
      } else if (this.checkMethod === "email") {
        this.resetIdentifier = this.emailValue;
        data = {
          identifier: this.emailValue,
          validate_for: "retrieve_via_email",
          vcode: this.emailCode
        };
      }
      this.validateCode(data);
    },
    // 调用验证码校验接口
    validateCode(data) {
      Object(new_login["i" /* httpValidateCode */])(data).then(res => {
        if (res.data && res.data.is_success) {
          this.setCodeErrorMsg("", false);
          this.resetToken = res.data.token;
          this.resetType = res.data.reset_type;
          // 进入密码设置页
          this.isCheckingPage = false;
          this.$refs.MobileComplexInput && this.$refs.MobileComplexInput.dispatchStop();
          this.$refs.EmailCountdown && this.$refs.EmailCountdown.stopRunTime();
        } else {
          this.setCodeErrorMsg(res === null || res === void 0 ? void 0 : res.err_msg, true);
        }
      }).catch(err => {
        var _err$data4;
        if (typeof err === "object" && (_err$data4 = err.data) !== null && _err$data4 !== void 0 && _err$data4.err_msg) {
          var _err$data5;
          this.setCodeErrorMsg((_err$data5 = err.data) === null || _err$data5 === void 0 ? void 0 : _err$data5.err_msg, true);
        } else {
          return Promise.reject(err);
        }
      });
    },
    // 显示/清除报错信息
    setCodeErrorMsg(msg, isError) {
      if (this.checkMethod === "mobile") {
        this.phoneCodeError = isError;
        this.phoneCodeErrorMsg = msg;
        if (isError) {
          this.phoneCode = "";
        }
      } else if (this.checkMethod === "email") {
        this.emailCodeError = isError;
        this.emailCodeErrorMsg = msg;
        if (isError) {
          this.emailCode = "";
        }
      }
    },
    // 密码框输入
    passwordInput(val) {
      this.newPasswordValue = val.replace(/\s|[\u4E00-\u9FA5]/g, "");
    },
    // 密码输入失焦
    passwordBlur() {
      if (!this.newPasswordValue) {
        this.passwordError = true;
        this.passwordErrorMsg = "请输入密码";
      } else if (this.newPasswordValue.length < 8) {
        this.passwordError = true;
        this.passwordErrorMsg = "密码不能少于8位字符";
      } else if (this.newPasswordValue.length > 20) {
        this.passwordError = true;
        this.passwordErrorMsg = "密码不能超过20位字符";
      } else if (!/^(?=.*\d)(?=.*[a-zA-Z])(?=.*[_!@#$%^&*])[\da-zA-Z_!@#$%^&*]{8,20}$/.test(this.newPasswordValue)) {
        this.passwordError = true;
        this.passwordErrorMsg = "密码请包含字母、数字与符号";
      } else {
        this.passwordError = false;
      }

      // 修改密码输入 需重新判断确认密码输入与输入密码是否一致
      if (this.confirmPasswordValue) {
        if (this.confirmPasswordValue !== this.newPasswordValue) {
          this.confirmError = true;
          this.confirmErrorMsg = "您输入的密码不一致";
        } else {
          this.confirmError = false;
          this.confirmErrorMsg = "";
        }
      }
    },
    // 确认密码框输入
    confirmInput(val) {
      this.confirmPasswordValue = val.replace(/\s|[\u4E00-\u9FA5]/g, "");
    },
    // 确认密码输入失焦
    confirmBlur() {
      if (this.confirmPasswordValue !== this.newPasswordValue) {
        this.confirmError = true;
        this.confirmErrorMsg = "您输入的密码不一致";
      } else {
        this.confirmError = false;
      }
    },
    // 返回登录页
    loginBack() {
      this.$emit("forgetPwd", false);
    },
    handleSelect(type) {
      this.checkMethod = type;
    },
    // 返回到校验页，重置密码页参数
    handleBack() {
      this.isCheckingPage = true;
      this.resetPasswordInfo();
    },
    // 返回校验页面清空设置密码页参数
    resetPasswordInfo() {
      this.newPasswordValue = "";
      this.confirmPasswordValue = "";
      this.passwordError = false;
      this.confirmError = false;
      this.passwordErrorMsg = "";
      this.confirmErrorMsg = "";
    },
    // 密码设置完成
    handleFinish() {
      if (this.passwordError || this.confirmError) return message_default()({
        message: "输入有误，请确认！",
        type: "warning"
      });
      const data = {
        password: this.newPasswordValue,
        token: this.resetToken,
        token_from: this.resetType,
        identifier: this.resetIdentifier
      };
      Object(new_login["g" /* httpResetPassword */])(data).then(res => {
        if (res.data && res.data.is_success) {
          message_default()({
            message: "密码设置成功",
            type: "success"
          });
          // 返回账号登录
          this.$emit("forgetPwd", false);
        }
      }).catch(err => {
        console.log("err", err);
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/login-component/src/retrieve.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_retrievevue_type_script_lang_js_ = (retrievevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/retrieve.vue?vue&type=style&index=0&id=4ae7ef57&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/login-component/src/retrieve.vue?vue&type=style&index=0&id=4ae7ef57&prod&scoped=true&lang=scss&

// CONCATENATED MODULE: ./packages/login-component/src/retrieve.vue






/* normalize component */

var retrieve_component = Object(componentNormalizer["a" /* default */])(
  src_retrievevue_type_script_lang_js_,
  retrievevue_type_template_id_4ae7ef57_scoped_true_render,
  retrievevue_type_template_id_4ae7ef57_scoped_true_staticRenderFns,
  false,
  null,
  "4ae7ef57",
  null
  
)

/* harmony default export */ var retrieve = (retrieve_component.exports);
// EXTERNAL MODULE: ./packages/tools.js
var packages_tools = __webpack_require__(11);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/index.vue?vue&type=script&lang=js&







/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "LoginComponent",
  components: {
    QuickAccount: quick_account,
    Retrieve: retrieve,
    WXLogin: wx_login,
    ThirdParty: third_party,
    Agreement: agreement
  },
  provide() {
    return {
      appendParamsFn: packages_tools["default"].appendLoginParams
    };
  },
  props: {
    logoType: {
      type: String,
      default: "new-logo"
    },
    // 快速登录： quick-login; 账号-邮箱登录：email-login; 账号-手机号登录：mobile-login; 微信登录：wx-login; 第三方登录：third-part-login
    initType: {
      type: String,
      default: "last-type"
    },
    // 定路由跳转的URL
    nextUrl: {
      type: [String, Function],
      default: "/list/"
    },
    // 弹框来源，（用于记录打开登录弹框的位置，埋点等）
    source: {
      type: String,
      default: ""
    },
    // 成功之后调用回调函数
    success: {
      type: Function,
      default: null
    },
    // spsspro
    openType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentType: this.initType,
      // 当前登录方式
      showAgreement: false,
      // 用户协议显隐
      accepted: false,
      // 用户协议是否同意
      isAccepted: false,
      // 第三方登录用户协议是否同意
      isThird: false,
      // 是否第三方登录打开的用户协议弹框
      showForget: false // 忘记密码显影
    };
  },

  mounted() {
    if (this.initType === "last-type") {
      this.currentType = getLastLoginType();
    }
    if (this.currentType === "wx-login") {
      this.isThird = true;
    }
  },
  methods: {
    // 控制用户协议弹框显隐
    dealAgreement(flag) {
      if (this.logoType !== "new-logo") {
        this.showAgreement = flag;
      } else {
        this.autoLogo();
      }
    },
    // 用户协议弹框按钮点击
    agreed(flag) {
      this.accepted = flag;
      this.showAgreement = false;
    },
    // 第三方登录，用户协议弹框按钮点击
    thirdAgreed(val) {
      this.isAccepted = val;
      this.showAgreement = false;
    },
    changeLoginType(val) {
      this.currentType = val;
      // 微信与手机图标切换时
      this.isThird = val === "wx-login";
    },
    // 第三方登录图标点击
    handleIconClick(val) {
      this.isThird = val;
    },
    // 展示密码找回模块
    showForgetPwd(flag) {
      this.showForget = flag;
    },
    // 登录成功回调
    loginSuccess(val) {
      this.$emit("loginSuccess", val);
    },
    viewCopy(type) {
      this[type] = true;
    },
    // 自动完成同意并登入
    autoLogo() {
      if (this.isThird) {
        this.isAccepted = true;
      } else {
        this.accepted = true;
      }
      this.showAgreement = false;
    }
  }
});
// CONCATENATED MODULE: ./packages/login-component/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var login_component_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-component/src/index.vue?vue&type=style&index=0&id=8d17a12c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/login-component/src/index.vue?vue&type=style&index=0&id=8d17a12c&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/login-component/src/index.vue






/* normalize component */

var src_component = Object(componentNormalizer["a" /* default */])(
  login_component_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "8d17a12c",
  null
  
)

/* harmony default export */ var src = (src_component.exports);
// CONCATENATED MODULE: ./packages/login-component/index.js

src.install = Vue => {
  Vue.component(src.name, src);
};
/* harmony default export */ var login_component = __webpack_exports__["default"] = (src);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/input.css");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/message");

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return httpGetVcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return httpQuickLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return httpUploadValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return httpCheckUploadValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpAccountLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return httpGetPhoneCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return httpValidateCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return httpResetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return httpPostAnswerRecord; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

let request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

/**
 * 是否显示图像验证码，短信验证码是否发送成功
 * @returns
 */
function httpGetVcode(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/quick_login/generate_vcode/", {
    ...params
  });
}

/**
 * 登录流程，新用户注册并登录，老用户直接登录，返回登录是否成功
 * @returns
 */
function httpQuickLogin(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/quick_login/", {
    ...params,
    redErrorMsg: false,
    useErrorTip: false
  });
}

/**
 * 获取上传短信内容信息(主动发短信流程内容获取)
 * @returns
 */
function httpUploadValidate(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/api/sms/upload/validate/", {
    ...params
  });
}

/**
 * 验证短信内容是否发送，并获取校验凭证
 * @returns
 */
function httpCheckUploadValidate(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/sms/upload/validate/", {
    ...params
  });
}

/**
 * 账号登录接口
 * @returns
 */
function httpAccountLogin(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/login/", {
    ...params,
    redErrorMsg: false,
    useErrorTip: false
  });
}

/**
 * 密码找回-发送手机/邮箱验证码
 * @returns
 */
function httpGetPhoneCode(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/vcode/generate/", {
    ...params,
    redErrorMsg: false,
    useErrorTip: false
  });
}

/**
 * 密码找回-验证验证码
 * @returns
 */
function httpValidateCode(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/vcode/validate/", {
    ...params,
    redErrorMsg: false,
    useErrorTip: false
  });
}

/**
 * 密码找回-设置密码
 * @returns
 */
function httpResetPassword(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/member/password/forget/", {
    ...params
  });
}

// 接口调用答题结束页引导, 新增自己的答题数据
function httpPostAnswerRecord(data) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post(`/app_api/common/api/answer_record/`, data);
}

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = require("blueimp-md5");

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-dialog/src/index.vue?vue&type=template&id=1c3702a3&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "wd-dialog",
        {
          staticClass: "login-dialog",
          class: _vm.openType ? "open-type" : "",
          attrs: {
            title: "",
            type: "large",
            visible: _vm.dialogVisile,
            "show-close": _vm.openType != "spsspro"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisile = $event
            },
            close: function($event) {
              _vm.dialogVisile = false
            }
          }
        },
        [
          _c(
            "div",
            { class: [`login-content ${_vm.logoType}`] },
            [
              !_vm.openType
                ? [_c("div", { staticClass: "logo-base" })]
                : _vm._e(),
              _vm._v(" "),
              _c("LoginComponent", {
                attrs: {
                  "init-type": _vm.initType,
                  "next-url": _vm.nextUrl,
                  source: _vm.source,
                  success: _vm.success,
                  "open-type": _vm.openType,
                  "logo-type": _vm.logoType
                },
                on: { loginSuccess: _vm.loginSuccess }
              })
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/login-dialog/src/index.vue?vue&type=template&id=1c3702a3&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dialog.css"
var dialog_css_ = __webpack_require__(14);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dialog"
var dialog_ = __webpack_require__(7);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// EXTERNAL MODULE: ./packages/login-component/index.js + 62 modules
var login_component = __webpack_require__(189);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-dialog/src/index.vue?vue&type=script&lang=js&



/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "LoginDialog",
  components: {
    "wd-dialog": dialog_default.a,
    LoginComponent: login_component["default"]
  },
  props: {
    // 左侧图片
    logoType: {
      type: String,
      default: "new-logo"
    },
    // 弹框显隐
    visible: {
      type: Boolean,
      default: false
    },
    // 快速登录： quick-login; 账号-邮箱登录：email-login; 账号-手机号登录：mobile-login; 微信登录：wx-login; 第三方登录：third-part-login
    initType: {
      type: String,
      default: "last-type"
    },
    // 定路由跳转的URL
    nextUrl: {
      type: [String, Function],
      default: "/list/"
    },
    // 弹框来源，（用于记录打开登录弹框的位置，埋点等）
    source: {
      type: String,
      default: ""
    },
    // 成功之后调用回调函数
    success: {
      type: Function,
      default: null
    },
    // spsspro
    openType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {
    dialogVisile: {
      get() {
        return this.visible;
      },
      set() {
        this.$emit("close");
      }
    }
  },
  mounted() {},
  methods: {
    // 登录成功回调
    loginSuccess(val) {
      this.$emit("loginSuccess", val);
    }
  }
});
// CONCATENATED MODULE: ./packages/login-dialog/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var login_dialog_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/login-dialog/src/index.vue?vue&type=style&index=0&id=1c3702a3&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/login-dialog/src/index.vue?vue&type=style&index=0&id=1c3702a3&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/login-dialog/src/index.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  login_dialog_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1c3702a3",
  null
  
)

/* harmony default export */ var src = (component.exports);
// CONCATENATED MODULE: ./packages/login-dialog/index.js

src.install = Vue => {
  Vue.component(src.name, src);
};
/* harmony default export */ var login_dialog = __webpack_exports__["default"] = (src);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/button");

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/complex-input.vue?vue&type=template&id=56518466&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["complex-input", { showHoverColor: _vm.showHoverColor }] },
    [
      _c(
        "WdInput",
        _vm._b(
          {
            class: [
              {
                "area-active": _vm.areaActive,
                "custom-error": _vm.isError
              }
            ],
            attrs: {
              placeholder: _vm.placeholder,
              maxlength: _vm.maxlength,
              autocomplete: "on",
              "auto-complete": "on"
            },
            on: {
              input: _vm.input,
              change: function($event) {
                return _vm.input("change")
              },
              focus: function($event) {
                return _vm.$emit("focus", _vm.valueMap)
              },
              blur: function($event) {
                return _vm.blur("inputBlur")
              }
            },
            model: {
              value: _vm.valueMap.value,
              callback: function($$v) {
                _vm.$set(
                  _vm.valueMap,
                  "value",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "valueMap.value"
            }
          },
          "WdInput",
          _vm.$attrs,
          false
        ),
        [
          _vm.useArea
            ? _vm._t(
                "prepend",
                function() {
                  return [
                    _c("AreaInput", {
                      ref: "AreaInput",
                      attrs: {
                        slot: "prepend",
                        offset: _vm.curOffset,
                        "append-to-body": _vm.appendToBody,
                        "set-aear-width": _vm.setAearWidth
                      },
                      on: {
                        input: _vm.input,
                        checkValue: item =>
                          _vm.$emit("checkValue", {
                            value: _vm.valueMap,
                            isHad: item
                          }),
                        focus: _vm.areaFocus,
                        change: function($event) {
                          return _vm.areaBlur("change")
                        },
                        blur: function($event) {
                          return _vm.areaBlur("areaBlur")
                        },
                        clickIcon: function($event) {
                          return _vm.areaFocus(!_vm.areaActive)
                        },
                        hide: function($event) {
                          return _vm.areaFocus(false)
                        },
                        popWidth: _vm.popWidth
                      },
                      slot: "prepend",
                      model: {
                        value: _vm.valueMap.preValue,
                        callback: function($$v) {
                          _vm.$set(_vm.valueMap, "preValue", $$v)
                        },
                        expression: "valueMap.preValue"
                      }
                    })
                  ]
                },
                { slot: "prepend" }
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.useCode
            ? _vm._t(
                "append",
                function() {
                  return [
                    _c("Countdown", {
                      ref: "Countdown",
                      attrs: {
                        slot: "append",
                        "is-active": _vm.isActive,
                        text: _vm.text,
                        time: _vm.time,
                        start: _vm.start
                      },
                      on: { stop: _vm.stop },
                      slot: "append"
                    })
                  ]
                },
                { slot: "append" }
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/complex-input/src/complex-input.vue?vue&type=template&id=56518466&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/input.css"
var input_css_ = __webpack_require__(19);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/input"
var input_ = __webpack_require__(9);
var input_default = /*#__PURE__*/__webpack_require__.n(input_);

// EXTERNAL MODULE: ./packages/complex-input/src/countdown.js
var countdown = __webpack_require__(149);

// EXTERNAL MODULE: ./packages/complex-input/src/areaInput.vue + 16 modules
var areaInput = __webpack_require__(135);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/complex-input.vue?vue&type=script&lang=js&




/* harmony default export */ var complex_inputvue_type_script_lang_js_ = ({
  name: "ComplexInput",
  components: {
    WdInput: input_default.a,
    Countdown: countdown["default"],
    AreaInput: areaInput["a" /* default */]
  },
  props: {
    // 使用前置区号
    useArea: {
      type: Boolean,
      default: true
    },
    // 使用后置倒计时
    useCode: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "请输入手机号码"
    },
    // 值的类型, 设置春数字验证,设置之后则只能输入数字
    valueType: {
      type: String,
      default: "number"
    },
    time: {
      type: Number,
      default: 60
    },
    value: {
      type: Object,
      default: () => ({})
    },
    maxlength: {
      type: Number,
      default: 11
    },
    popWidth: {
      type: Number,
      default: 340
    },
    offset: {
      type: Number,
      default: -15
    },
    // 是不是激活颜色倒计时
    isActive: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    // 继承countdown 的start, 是否开始倒计时
    start: {
      type: Function,
      default: () => {
        return Promise.resolve(false);
      }
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    setAearWidth: {
      type: Function,
      default: null
    },
    showHoverColor: {
      type: Boolean,
      default: true
    }
  },
  emits: {
    start: "计时器开始函数",
    stop: "计时器关闭函数",
    dispatchStop: "外部事件，手动关闭计数器"
  },
  data() {
    return {
      valueMap: {
        value: "",
        preValue: "86"
      },
      text: "发送验证码",
      areaActive: false,
      // 当前激活状态
      curOffset: this.offset
    };
  },
  watch: {
    value: {
      handler(cval) {
        this.valueMap = {
          ...this.valueMap,
          ...cval
        };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    input(type, isHad) {
      if (this.valueType === "number") this.valueMap.value = String(this.valueMap.value || "").replace(/\D/g, "");
      if (type === "change") {
        this.$emit("change", {
          value: this.valueMap,
          isHad
        });
      } else {
        // eslint-disable-next-line no-underscore-dangle
        const _isHad = this.getIsHad();
        this.$emit("input", this.valueMap, _isHad);
      }
    },
    // 获取焦点
    areaFocus(type) {
      this.areaActive = type;
    },
    // 停止倒计时
    stop() {
      this.$emit("stop");
      this.text = "重新发送";
    },
    // 外部出发关闭计时器
    dispatchStop() {
      this.$refs.Countdown && this.$refs.Countdown.stopRunTime();
    },
    // 失去焦点的时候
    blur(type) {
      const isHad = this.getIsHad();
      // type = areaBlur 前置失去焦点，
      this.$emit("blur", {
        type,
        value: this.valueMap,
        isHad
      });
    },
    // 前置焦点失去之后
    areaBlur() {
      let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "areaBlur";
      this.areaFocus(false);
      this.blur(type);
    },
    // 获取子对象的数据. 外层使用，和内从调用
    getIsHad() {
      var _this$$refs, _this$$refs$AreaInput;
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.valueMap.preValue;
      return ((_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$AreaInput = _this$$refs.AreaInput) === null || _this$$refs$AreaInput === void 0 ? void 0 : _this$$refs$AreaInput.checkValueHad(value)) || undefined;
    },
    // 手动执行倒计时
    startRunTime() {
      this.$refs.Countdown.startRunTime();
    }
  }
});
// CONCATENATED MODULE: ./packages/complex-input/src/complex-input.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_complex_inputvue_type_script_lang_js_ = (complex_inputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/complex-input.vue?vue&type=style&index=0&id=56518466&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/complex-input/src/complex-input.vue?vue&type=style&index=0&id=56518466&prod&scoped=true&lang=scss&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/complex-input/src/complex-input.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_complex_inputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "56518466",
  null
  
)

/* harmony default export */ var complex_input = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/countdown.vue?vue&type=template&id=ef0b28ce&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["countdown", { isActive: _vm.isActive }],
      style: {
        "--activeColor": _vm.activeColor,
        "--defaultColor": _vm.defaultColor
      },
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.handClick.apply(null, arguments)
        }
      }
    },
    [
      _vm._v(
        "\n    " +
          _vm._s(!_vm.isStart ? _vm.text : _vm.runtimeText) +
          " " +
          _vm._s(_vm.kyname.name) +
          "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/complex-input/src/countdown.vue?vue&type=template&id=ef0b28ce&scoped=true&

// EXTERNAL MODULE: ./packages/tools.js
var tools = __webpack_require__(11);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/countdown.vue?vue&type=script&lang=js&

const {
  hooks: {
    useReactive
  }
} = tools["default"];
/* harmony default export */ var countdownvue_type_script_lang_js_ = ({
  tooltip: "发送验证码",
  name: "Countdown",
  props: {
    // 时间步伐 的大小 单位秒
    speed: {
      type: Number,
      default: 1
    },
    //  等待下显示的文字
    text: {
      type: String,
      default: "发送验证码"
    },
    // 倒计算时间
    time: {
      type: Number,
      default: 60
    },
    // 获取焦点颜色
    activeColor: {
      type: String,
      default: "#2672FF"
    },
    // 默认颜色
    defaultColor: {
      type: String,
      default: "#999999"
    },
    // 是不是激活激活状态
    isActive: {
      type: Boolean,
      default: false
    },
    // 倒计时显示内容的函数
    /**
     * @params Number  {Number}  当前倒计时的时间
     * @return  {String}  倒计时的时候每一次轮询应该显示的内动
     */
    countdownTask: {
      type: Function,
      default: null
    },
    /**
     *  是否开始执行倒计时，
     * @return {Boolean} true 执行倒计时
     *  */
    start: {
      type: Function,
      default: () => true
    }
  },
  data() {
    return {
      isStart: false,
      runtime: this.time,
      runtimeText: "",
      // 倒计时显示文字
      handle: null,
      kyname: useReactive("kjo2", () => ({
        name: "这是一个对象"
      }))
    };
  },
  methods: {
    async handClick() {
      if (!this.isActive) return; // 内部循环判断
      if (!(await this.start(this.startRunTime))) return; // 外部循环判断
      this.startRunTime();
    },
    // 执行倒计时
    runtimeAction() {
      // 倒计时开始
      this.handle = setInterval(() => {
        if (this.runtime > 0) {
          this.runtime--;
          // 自定义倒计时显示的内容
          if (this.countdownTask) return this.countdownTask(this.runtime);
          // 默认执行行为
          const text = this.runtime === 0 ? "" : `(${this.runtime || ""})`;
          this.runtimeText = `重新发送${text}`;
        } else {
          this.stopRunTime();
        }
      }, this.speed * 1000);
    },
    startRunTime() {
      this.runtimeText = this.countdownTask // 如果自定义倒计时函数的显示内容，则返回值为显示内容
      ? this.countdownTask(this.runtime) : `重新发送(${this.runtime})`;
      this.isStart = true;
      this.runtimeAction();
    },
    // 关闭动画
    stopRunTime() {
      clearInterval(this.handle);
      this.isStart = false;
      this.runtime = this.time;
      this.$emit("stop"); // 停止后的调用
    }
  }
});
// CONCATENATED MODULE: ./packages/complex-input/src/countdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_countdownvue_type_script_lang_js_ = (countdownvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/complex-input/src/countdown.vue?vue&type=style&index=0&id=ef0b28ce&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/complex-input/src/countdown.vue?vue&type=style&index=0&id=ef0b28ce&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/complex-input/src/countdown.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_countdownvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "ef0b28ce",
  null
  
)

/* harmony default export */ var countdown = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQueryString; });
/* unused harmony export hideMobile */
/* unused harmony export isNotEmpty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return distinguishUserAgentUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return loadJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return urlDelP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataURLtoFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadGenerateQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserAgentInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isWxMiniApp; });
/* unused harmony export insertHTML */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleAppClintPostMes; });
// 获取url链接中的参数
function getQueryString(name) {
  let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
  const r = source.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 手机打*号
function hideMobile(mobile) {
  if (!mobile) return "";
  return `${mobile.substr(0, 3)}****${mobile.substr(-4)}`;
}

// 判断变量是否为空
function isNotEmpty(obj) {
  if (typeof obj === "undefined" || obj == null) {
    return false;
  }
  if (typeof obj === "function") {
    return true;
  }
  if (obj.constructor == Number) {
    if (obj) {
      return true;
    }
    return false;
  }
  if (typeof obj === "string") {
    if (obj !== "") {
      return true;
    }
    return false;
  }
  return Object.keys(obj).length > 0;
}

// 区分浏览器类型
function distinguishUserAgentUtils(userAgent) {
  if (typeof window !== "undefined") {
    var _window, _window$navigator, _window2;
    const ua = userAgent || ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent.toLowerCase());
    const isTouTiaoMiniApp = ua.includes("toutiaomicroapp");
    const isQQMiniApp = ua.includes("qq") && ua.includes("miniprogram") && !ua.includes("micromessenger");
    const isBaiduMiniApp = ua.includes("baiduboxapp") && ua.includes("swan");
    const isWeixinMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    return {
      isEdge: ua.includes("Edge"),
      isFF: ua.includes("Firefox"),
      isOpera: ua.includes("Opera"),
      isBB: ua.includes("BlackBerry"),
      isChrome: ua.includes("Chrome"),
      isMaxthon: ua.includes("Maxthon"),
      isFeishu: ua.includes("Lark/"),
      isIos: /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isSafari: ua.includes("Safari") && !ua.includes("Chrome"),
      isIE: !!window.ActiveXObject || "ActiveXObject" in window,
      isMobile: /(iPad|iPhone|iPod|Opera Mini|Android.*Mobile|NetFront|PSP|BlackBerry|Windows Phone)/gi.test(ua),
      isWeixin: ua.match(/MicroMessenger/i) === "micromessenger",
      isWeibo: ua.match(/WeiBo/i) === "weibo",
      isWxwork: ua.match(/wxwork/i) === "wxwork",
      isQQ: ua.match(/QQ/i) === "qq",
      isIosApp: ua.includes("wenjuan/") && /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isApp: ua.includes("wenjuan/") || ua.includes("android_app/"),
      isTeacherApp: ua.includes("campusteacher/") || ua.includes("campusstudent/"),
      isHarmony: ua.includes("harmony_wenjuanwrap"),
      isAndroidApp: ua.includes("android_app/"),
      isAndroid: (ua.match(/android/i) === "android" || ua.match(/adr/i) === "adr") && ua !== "android_app/1.0.0",
      // ios android 客户端
      isNative: ua.match(/android_app\//i) === "android_app/" || ua.match(/wenjuan\//i) === "wenjuan/",
      isBaiying: ua.includes("baiying"),
      isDingding: ua.includes("DingTalk"),
      isTencentWemeet: ua.includes("tencent_wemeet"),
      isMac: /macintosh|mac os x/i.test(ua),
      isPWA: (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.matchMedia("(display-mode: minimal-ui)").matches,
      isUc: ua.includes("ucbrowser"),
      isCloudpay: ua.includes("unionpay"),
      isDingTalk: ua.includes("dingtalk"),
      isTencentMeeting: ua.includes("tencent_wemeet"),
      isQuark: ua.includes("quark"),
      isTouTiaoMiniApp,
      isQQMiniApp,
      isBaiduMiniApp,
      isWeixinMiniApp,
      isMiniApp: isTouTiaoMiniApp || isQQMiniApp || isBaiduMiniApp || isWeixinMiniApp,
      isHarmonyApp: ua.includes("harmonyos") && ua.includes("wenjuan/") && !ua.includes("android_app/")
    };
  }
  return {};
}

// js中动态加载script，并在load后触发cb
function loadJS(url, callback) {
  const script = document.createElement("script");
  const fn = callback || function () {};
  script.type = "text/javascript";
  // IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    // 其他浏览器
    script.onload = function () {
      fn();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

// 删除URL上某个参数
function urlDelP(url, name) {
  const urlArr = url.split("?");
  if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
    const query = urlArr[1];
    const obj = {};
    const arr = query.split("&");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    const querys = JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    let searchs = "";
    if (querys) {
      searchs = `?${querys}`;
    }
    const urlte = urlArr[0] + searchs;
    return urlte;
  }
  return url;
}
/**
 * 将base64转换为文件
 * @param {String} dataUrl 图片地址
 * @param {String} imgType 图片类型 传png,jpg等 而不是image/png
 * @return blob文件
 */
function dataURLtoFile(dataUrl, imgType) {
  var _arr$;
  // 替换base64图片的图片类型
  if (imgType) {
    const types = dataUrl.match(/data:image[^;]*;base64,/gi);
    types.forEach(type => {
      dataUrl = dataUrl.replace(new RegExp(`${type}`, "g"), `data:image/${imgType};base64,`);
    });
  }
  const arr = dataUrl.split(",");
  const reg = (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : _arr$.match(/:(.*?);/);
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: reg ? reg[1] : ""
  });
}

// 前端生成二维码-下载二维码
function downloadGenerateQRCode(url) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "图片";
  if (window.navigator.msSaveOrOpenBlob) {
    // ie
    const bstr = atob(url.split(",")[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr]);
    window.navigator.msSaveOrOpenBlob(blob, `${name}.png`);
  } else {
    // 非ie
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", `${name}.png`);
    a.click();
  }
}
function getUserAgentInfo() {
  const {
    userAgent
  } = navigator;
  let version;
  if (/opera/i.test(userAgent) || /OPR/i.test(userAgent)) {
    version = getVersion(userAgent, "OPR/(\\d+\\.+\\d+)");
    return ["Opera", version];
  }
  if (/compatible/i.test(userAgent) && /MSIE/i.test(userAgent)) {
    version = getVersion(userAgent, "MSIE (\\d+\\.+\\d+)");
    return ["IE", version];
  }
  if (/Edg/i.test(userAgent)) {
    version = getVersion(userAgent, "Edg/(\\d+\\.+\\d+)");
    return ["Edge", version];
  }
  if (/Firefox/i.test(userAgent)) {
    version = getVersion(userAgent, "Firefox/(\\d+\\.+\\d+)");
    return ["Firefox", version];
  }
  if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
    version = getVersion(userAgent, "Version/(\\d+\\.+\\d+)");
    return ["Safari", version];
  }
  if (/Chrome/i.test(userAgent) && /Safari/i.test(userAgent)) {
    version = getVersion(userAgent, "Chrome/(\\d+\\.+\\d+)");
    return ["Chrome", version];
  }
  if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
    return ["IE", "any"];
  }
}
function getVersion(userAgent, reg) {
  const reBrowser = new RegExp(reg);
  reBrowser.test(userAgent);
  return parseInt(RegExp.$1);
}

// 判断是否是小程序环境
function isWxMiniApp() {
  try {
    var _window3, _window3$navigator, _window3$navigator$us;
    const ua = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$navigator = _window3.navigator) === null || _window3$navigator === void 0 ? void 0 : (_window3$navigator$us = _window3$navigator.userAgent) === null || _window3$navigator$us === void 0 ? void 0 : _window3$navigator$us.toLowerCase();
    const uaIsWxMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    if (uaIsWxMiniApp) return true;
    const appname = getQueryString("appname");
    if (appname === "wj-miniapp") return true;
    if (window.__wxjs_environment === "miniprogram") return true;
  } catch (error) {}
}

// insert HTML
function insertHTML(html, editor) {
  if (window.getSelection) {
    // IE9 and non-IE
    const sel = window.getSelection();
    if (editor && sel.focusNode !== editor && sel.focusNode.parentNode !== editor) {
      editor.innerHTML += html;
      return;
    }
    if (sel.getRangeAt && sel.rangeCount) {
      let range = sel.getRangeAt(0);
      range.deleteContents();
      const el = document.createElement("div");
      el.innerHTML = html;
      const frag = document.createDocumentFragment();
      let node = el.firstChild;
      let lastNode;
      while (node) {
        lastNode = frag.appendChild(node);
        node = el.firstChild;
      }
      range.insertNode(frag);

      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type !== "Control") {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
}

// app端交互
function handleAppClintPostMes() {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    isIosApp,
    isAndroidApp,
    isHarmonyApp
  } = distinguishUserAgentUtils(navigator.userAgent);
  if (isHarmonyApp) {
    window.ohosCallNative && window.ohosCallNative.postMessage({
      type,
      data
    });
  } else if (isIosApp) {
    var _window$webkit;
    if ((_window$webkit = window.webkit) !== null && _window$webkit !== void 0 && _window$webkit.messageHandlers) {
      window.webkit.messageHandlers.app_nativeInteraction.postMessage({
        type,
        data
      });
    }
  } else if (isAndroidApp && window.android) {
    window.android.postMessage(JSON.stringify({
      type,
      data
    }));
  }
}

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/popover");

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/loading");

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports = require("lodash/debounce");

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return del; });
/* unused harmony export getParseDomain */
// 操作cookie
function set(c_name, value, expiredays, beforeDomain) {
  let exdate;
  const domain = getParseDomain(beforeDomain);
  // expiredays 可以是Number类型的过期天数
  // 也可以是String类型的日期字符串
  // 还可以是Date类型的
  if (expiredays && expiredays instanceof Date) {
    // expiredays是Date类型
    exdate = expiredays;
  } else if (expiredays && isDate(expiredays)) {
    // expiredays是日期字符串
    exdate = new Date(expiredays).toUTCString();
  } else {
    // expiredays为Nubmer类型或者未设置
    const newDate = new Date();
    expiredays = !expiredays || expiredays != Number(expiredays) ? 1 : expiredays;
    newDate.setDate(newDate.getDate() + expiredays);
    exdate = newDate.toUTCString();
  }
  document.cookie = `${c_name}=${escape(value)};expires=${exdate};path=/;domain=${domain}`;
}
function get(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(`${c_name}=`);
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}
function del(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = get(name);
  const domain = getParseDomain();
  if (cval != null) {
    document.cookie = `${name}=${cval};expires=${exp.toUTCString()};path=/;domain=${domain}`;
  }
}
// 获取设置cookie的domain（和后端设置逻辑保持统一）
// 适配多域名，设置 cookie 到一级域名
function getParseDomain(beforeDomain) {
  let hostname = location.hostname.toLocaleLowerCase();
  // 获取一级域名
  const arr = hostname.split(".");
  hostname = arr.length > (hostname.includes(".com.cn") ? 3 : 2) ? arr.slice(1).join(".") : hostname;
  let domain = beforeDomain || hostname;
  const reLocalhost = /^(192.168.)|^(127.0.0.)/;
  if (reLocalhost.test(domain)) {
    // domain = domain;
  } else if (domain === "localhost") {
    domain = hostname;
  } else {
    domain = `.${domain}`;
  }
  return domain;
}

// 验证字符串str是否为日期格式的字符串
function isDate(str) {
  const reg = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
  if (!str) return false;
  if (reg.test(str) && RegExp.$2 <= 12 && RegExp.$3 <= 31 && RegExp.$4 <= 23 && RegExp.$5 <= 59 && RegExp.$6 <= 59) {
    return true;
  }
  return false;
}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dialog");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/button.css");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/input");

/***/ })

/******/ })["default"];